// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T17:48:45.463Z
// Property: Skyhouse Apartments (ID: 6767906449167707)
// Collections: 9 amenities, 18 floorplans (live), 23 photos, 81 POIs, 4 reviews, 5 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162467",
  "multihub_property_id": "6767906449167707",
  "property_external_id": "2506713",
  "property_zillow_url": "https://www.zillow.com/apartments/salt-lake-city-ut/skyhouse/BqkwMD/",
  "property_apartments_url": "https://www.apartments.com/skyhouse-apartments-salt-lake-city-ut/5k8mh0n/",
  "property_google_business_url": "https://www.google.com/maps/place/Skyhouse+Apartments/@40.7719799,-111.9001853,866m/data=!3m2!1e3!4b1!4m6!3m5!1s0x8752f58f17f2ce29:0xc22dbc43177dafda!8m2!3d40.7719799!4d-111.9001853!16s%2Fg%2F11fmb_0mwc?entry=ttu&g_ep=EgoyMDI2MDgxNy4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "skyhouse-apartments",
  "property_name": "Skyhouse Apartments",
  "property_website_url": "https://www.liveatskyhouse.com/",
  "property_domain": "https://www.liveatskyhouse.com/",
  "property_address": "308 W North Temple St",
  "property_full_address": "308 W North Temple St, Salt Lake City, UT 84101",
  "property_address_1": "308 W North Temple St",
  "property_address_2": null,
  "property_address_city": "Salt Lake City",
  "property_address_state": "UT",
  "property_address_zip_full": null,
  "property_address_zip": "84101",
  "property_address_country": "US",
  "property_address_county": "Salt Lake County",
  "property_neighborhood_address": "Capitol Hill",
  "property_address_latitude": "40.7719799",
  "property_address_longitude": "-111.9001853",
  "property_email": "skyhouse@pprmco.com, hchristensen@pprmco.com",
  "property_phone": "(385) 247-0063",
  "property_call_tracking_phone": "5614982600",
  "property_company_name": "Parkplace Residential",
  "property_company_url": "https://www.pprmco.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Downtown energy, Capitol Hill views.</strong> Skyhouse pairs polished studio, one-, and two-bedroom homes with rooftop skyline and Wasatch views, modern finishes, and easy TRAX access—bringing the city, mountains, and transit close at hand. Schedule a tour today.</p>",
  "property_long_description": "<p><strong>Live where downtown energy meets Capitol Hill views.</strong> At Skyhouse Apartments, you’re minutes from City Creek Center, The Gateway, Delta Center, and the historic Marmalade District, with North Temple TRAX nearby for light-rail connections across Salt Lake City and to the airport.</p><p>Inside, choose from <a href=\"/floor-plans\">studio, one-, and two-bedroom layouts</a> with polished finishes like quartz or granite countertops, stainless steel appliances, hardwood-style flooring, kitchen islands, walk-in closets, in-home laundry, and private balconies or patios in select homes. Step outside your door to a rooftop deck with fire pits, BBQ grills, and sweeping Wasatch and skyline views, plus a fitness center, yoga studio, clubhouse, business and conference spaces, bike storage, EV charging, controlled-access garage parking, package service, valet trash, and a pet wash station.</p><p>From Capitol Hill’s tree-lined streets and Utah State Capitol landmarks to creekside green space at Memory Grove and dining along North Temple, Skyhouse gives you a polished home base with the city, mountains, and transit close at hand. Explore more <a href=\"/amenities\">community amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
  "property_featured_image_media": {
    "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
    "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
    "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
    "width": 2048,
    "height": 1368
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "240",
  "property_year_built": "2019",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "81.66666666666667",
  "property_admin_fee": "250",
  "property_application_fee": "50",
  "property_fees_deposit_info": "Deposit: $500",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "65",
  "property_pet_restrictions": "We allow up to two pets per unit. Approved pets include dogs (subject to breed restrictions), indoor cats, small caged birds, fish in aquariums up to 20 gallons, and small caged rodents such as hamsters and guinea pigs. The following animals are not permitted: reptiles, amphibians, insects, ferrets, rabbits, exotic animals, livestock, or poultry.",
  "property_pet_policy_description": "Fee and Pet Rent is Per Pet",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://liveatskyhouse.securecafe.com/onlineleasing/skyhouse-apartments/floorplans.aspx",
  "property_resident_portal_url": "https://liveatskyhouse.securecafenet.com/residentservices/skyhouse-apartments/userlogin",
  "property_apply_now_url": "https://liveatskyhouse.securecafe.com/onlineleasing/skyhouse-apartments/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a02540-a404-736f-98e6-18324f4e3234.webp",
  "property_primary_logo_media": {
    "alt_text": "Skyhouse logo with address 308 North Temple.",
    "public_id": "01a02540-a404-736f-98e6-18324f4e3234",
    "storage_key": "property/6767906449167707/01a02540-a404-736f-98e6-18324f4e3234.webp",
    "width": 292,
    "height": 72
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162467/01a01ae2-f0b2-7046-ae69-25afcce6a6e0.webp",
  "property_fav_icon_media": {
    "alt_text": "ParkPlace Residential logo",
    "public_id": "01a01ae2-f0b2-7046-ae69-25afcce6a6e0",
    "storage_key": "company/5767906449162467/01a01ae2-f0b2-7046-ae69-25afcce6a6e0.webp",
    "width": 250,
    "height": 125
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a02540-ddd2-7216-98b9-ef1a8aa4700c.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a02540-ddd2-7216-98b9-ef1a8aa4700c",
    "storage_key": "property/6767906449167707/01a02540-ddd2-7216-98b9-ef1a8aa4700c.webp",
    "width": 292,
    "height": 72
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a02540-d22e-72d3-b481-832edd3eb5bb.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a02540-d22e-72d3-b481-832edd3eb5bb",
    "storage_key": "property/6767906449167707/01a02540-d22e-72d3-b481-832edd3eb5bb.webp",
    "width": 292,
    "height": 72
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto/company/5767906449162467/01a01ae2-f0b2-7046-ae69-25afcce6a6e0.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#1B2A4A",
  "property_secondary_color": "#C9A94D",
  "property_font_color": "#232323",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "507 - 1118",
  "property_sqft_min": "507",
  "property_sqft_max": "1118",
  "property_price_range": "1050 - 2705",
  "property_price_min": "1050",
  "property_price_max": "2705",
  "property_available_units": 44,
  "property_facebook_url": "https://www.facebook.com/SkyhouseApts",
  "property_instagram_url": "https://www.instagram.com/skyhouseapartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJKc7yF4_1UocR2q99F0O8LcI",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Skyhouse Apartments",
  "property_home_romance_title": "Experience the Joy of Your New Apartment Home Here",
  "property_home_amenities_blurb": "<p><strong>Amenities with skyline energy.</strong> Start with the rooftop terrace—fire pits, BBQ grills, lounge seating, and open city-and-mountain views above Salt Lake City. Inside, modern finishes like stainless steel appliances, quartz or granite countertops, kitchen islands, in-home washer/dryer, and high ceilings keep the style sharp, while garage parking, EV charging, package service, bike storage, and pet wash add everyday ease.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room to choose.</strong> Skyhouse Apartments offers studios, one-bedroom homes, and two-bedroom layouts, including select dens for added flexibility. Inside, open kitchens, stainless steel appliances, quartz or granite countertops, in-home washer/dryer, walk-in closets, and high ceilings keep each space polished and practical. Select residences add private balconies or patios, mountain or sunset views, corner or end locations, and larger balcony options.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at Skyhouse.</strong> Preview bright kitchens with oversized islands, stone countertops, stainless steel appliances, high ceilings, big windows, and select balconies or decks with mountain, skyline, or sunset views. Then head up to the roof terrace for lounge seating, grills, fire pits, and open-air sightlines that bring the Skyhouse name to life.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Capitol Hill texture, downtown momentum.</strong> Skyhouse places you between Marmalade’s historic streets, Center Street dining and nightlife, and North Temple transit for easy trips across Salt Lake and beyond. Grab dinner at Arlo, pizza at Taverna, or a quiet stop at Marmalade Branch Library, then head uphill to Memory Grove or City Creek Canyon for shaded paths and canyon views. Explore the map to see what’s close.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents love the Skyhouse experience.</strong> Reviews highlight responsive service, clean modern spaces, and a rooftop setting that stands out for downtown Salt Lake City and mountain views—especially at sunset. Read more to see why the well-kept amenities, central location, and quiet, secure feel leave a lasting impression.</p>",
  "property_neighborhood_blurb": "<p><strong>Capitol Hill at street level, downtown within easy reach.</strong> From Skyhouse, the neighborhood feels layered: historic Marmalade streets climbing toward the Utah State Capitol, a growing food-and-nightlife pocket around Center Street, and North Temple transit close by when you want the airport, downtown, Ogden, or Provo without the drive. Make plans around dinner at Arlo, pizza at Taverna, a stop at Mono Tape Club, or a visit to Marmalade Branch Library overlooking the plaza. When the day calls for open air, Memory Grove and City Creek Canyon put shaded paths and canyon scenery just uphill. Use the map below to trace your next coffee run, train ride, park walk, or night out—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Skyhouse connects it all.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that earn their view.</strong> At Skyhouse Apartments, your day can move from a cardio session to a rooftop sunset without leaving the building. The roof terrace is the signature—fire pits, BBQ grills, lounge seating, and wide-open city-and-mountain sightlines made for unwinding above Salt Lake City.</p><p>Inside, polished apartment finishes keep the backdrop just as sharp, with stainless steel appliances, quartz or granite countertops, kitchen islands, in-home washer/dryer, high ceilings, and select balconies or patios. Everyday conveniences—controlled access, garage parking, package service, valet trash, EV charging, bike storage, business and conference spaces, and a pet wash station—help the details run smoothly. Browse the <a href=\"/gallery\">amenity photos</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Skyhouse brings comfort, utility, and skyline style together.</p>",
  "property_applynow_blurb": "<p><strong>Start your next chapter at Skyhouse.</strong> Choose a studio, one-, or two-bedroom apartment with polished finishes, in-home laundry, and select private balconies or patios—then enjoy a downtown home base with Capitol Hill views, rooftop spaces, and TRAX nearby. Ready to make it yours? Apply online today.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Connect with the Skyhouse Apartments leasing team for help planning your visit to our downtown Salt Lake City location near Capitol Hill views and North Temple TRAX connections. We’re here to make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Skyhouse Apartments?</strong> Start here for quick answers on leasing, community features, floor plans, and everyday living at our downtown Salt Lake City apartments. If you don’t see what you need, the leasing team is happy to help or help you schedule a tour.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your next chapter at Skyhouse Apartments.</strong> Start with streamlined studios, choose from a broad collection of one-bedroom homes, or spread out in two-bedroom designs—including select den layouts for extra flexibility. Each floor plan is built for everyday ease, with open kitchens, stainless steel appliances, quartz or granite countertops, in-home washer/dryer, walk-in closets, high ceilings, and private balconies or patios available in select residences. Filter the cards below by bedrooms, price, and availability, then compare details like corner or end positions, mountain or sunset views, and larger balcony options. When a plan feels right, explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite Salt Lake City apartment in person.</p>",
  "property_gallery_blurb": "<p><strong>See Skyhouse from every angle.</strong> Browse a gallery that turns polished details into a clear picture of the community: bright kitchens with oversized islands, stainless steel appliances, and stone countertops; living areas framed by high ceilings and big windows; and select balconies or decks that open to mountain, skyline, or sunset views. Community photos move the story upstairs to the roof terrace, where lounge seating, grills, fire pits, and open-air sightlines make the building’s name feel literal. You’ll also spot the fitness center, clubhouse, game room, work-friendly spaces, bike storage, and pet wash that round out the experience. After the photos, compare <a href=\"/floor-plans\">studio, one-, and two-bedroom layouts</a>, explore <a href=\"/amenities\">amenity details</a>, or <a href=\"/schedule-a-tour\">see Skyhouse in person</a>.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Skyhouse on the map.</strong> See available apartments alongside the downtown connections, Capitol Hill surroundings, North Temple TRAX access, and nearby city-to-mountain highlights that make this Salt Lake City address stand out.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, perches, and quiet corners.</strong> At Skyhouse Apartments, approved pets can settle into the same polished routine you do, with roomy layouts, easy-clean finishes, and select balconies or patios for fresh-air moments above Capitol Hill. After a muddy walk or snowy sidewalk stroll, the on-site <a href=\"/amenities\">pet washing station</a> helps keep cleanup simple.</p><p>Step outside for quick neighborhood walks, or head toward nearby Freedom Trail, Salt Lake City’s off-leash area north of Memory Grove, when it is time for more room to roam. With controlled access, package service, elevators, and door-to-door trash pickup supporting daily life, caring for your pet feels a little more effortless. Have questions about approved pets, fees, or breed guidelines? <a href=\"/contact-us\">Contact the leasing team</a> before you tour.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Skyhouse experience.</strong> Love the Capitol Hill views, polished apartment finishes, rooftop deck, and downtown Salt Lake City connection? Invite a friend to explore our <a href=\"/floor-plans\">studio, one-, and two-bedroom homes</a> and see why Skyhouse makes the city feel close at hand.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Skyhouse Apartments.</strong><br>Pay rent, submit maintenance requests, and manage account details in one convenient place. With polished apartment finishes and thoughtful services like package service, valet trash, controlled-access garage parking, and EV charging, everyday living stays streamlined from home.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying about Skyhouse.</strong> As you read the reviews, you’ll notice the same details come up again and again: responsive service, a clean modern setting, and a rooftop experience residents call the highlight of the community.</p><p>Residents praise the “unbeatable” downtown SLC and mountain views, especially at sunset, along with well-maintained shared spaces and a location that keeps the city close without feeling overwhelming. Many also call out the friendly, helpful team and the quiet, secure feel of the building. Browse the reviews below to hear firsthand what makes life at Skyhouse Apartments stand out.</p>",
  "property_created_at": "1787157690471",
  "property_scheduletour_blurb": "<p><strong>See Skyhouse from the rooftop down.</strong><br>Tour polished studio, one-, and two-bedroom homes with elevated finishes, then take in the rooftop deck, skyline views, fitness spaces, and thoughtful everyday conveniences in person. Schedule your tour and picture downtown Salt Lake City living with Capitol Hill views close at hand.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>Our leasing team will follow up soon. In the meantime, picture polished studio, one-, and two-bedroom homes, rooftop views, and a connected downtown location with TRAX, city energy, and the mountains close at hand.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through your options before you arrive.</strong> Start with the Hempstead #420 tour, then compare one-bedroom perspectives in Nottoway and Whitehall, step into the added flexibility of Searles + Den, or preview the room-to-room flow of the two-bedroom, two-bath Arden layout. Each virtual tour helps you look past the floor plan and see how the space actually lives—from open kitchens and in-home laundry to closet placement, natural light, and where a balcony, deck, or view feature may shape the feel of the home.</p><p>Use these apartment tours to narrow your favorites from anywhere, revisit the details at your pace, and then check current <a href=\"/floor-plans\">floor plan</a> availability or <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see Skyhouse Apartments in Salt Lake City in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Skyhouse Apartments",
  "property_seo_title_home": "Skyhouse Apartments |  Apartments in Salt Lake City, UT",
  "property_seo_description_home": "Elevate your lifestyle at Skyhouse Apartments in Salt Lake City! Choose from stylish studio to two-bedroom floor plans, with premium amenities to match.",
  "property_seo_title_floorplans": "Floor Plans | Salt Lake City, UT Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Skyhouse Apartments in Salt Lake City. From cozy studios to spacious two-bedrooms, view all our flexible floor plans today!",
  "property_seo_title_amenities": "Amenities | Salt Lake City, UT Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Skyhouse Apartments, Salt Lake City—luxury amenities, modern designs, and vibrant community activities await!",
  "property_seo_title_gallery": "Gallery | Apartments in Salt Lake City, UT",
  "property_seo_description_gallery": "Elevate your lifestyle at Skyhouse Apartments in Salt Lake City! Enjoy stunning views, spacious floor plans, and top-notch amenities. Picture your new home!",
  "property_seo_title_virtualtours": "Virtual Tours | Skyhouse Apartments Apartments",
  "property_seo_description_virtualtours": "Discover vibrant living at Skyhouse Apartments in Salt Lake City! Take our virtual tour to find your ideal studio, one, or two-bedroom home!",
  "property_seo_title_interactivemap": "Interactive Map | Skyhouse Apartments Apartments",
  "property_seo_description_interactivemap": "Elevate your lifestyle at Skyhouse Apartments in Salt Lake City. Use our interactive map to find your perfect studio, one, or two-bedroom oasis today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Salt Lake City, UT",
  "property_seo_description_neighborhood": "Experience Salt Lake City living at Skyhouse Apartments! Uncover local favorites and vibrant hotspots just steps away from your new home.",
  "property_seo_title_contact": "Contact Us | Skyhouse Apartments",
  "property_seo_description_contact": "Reach new heights at Skyhouse Apartments in Salt Lake City! From studios to two-bedrooms, our leasing team is ready to assist you in finding your perfect home.",
  "property_seo_title_faqs": "FAQs | Apartments in Salt Lake City, UT",
  "property_seo_description_faqs": "Discover FAQs at Skyhouse Apartments in Salt Lake City. Explore our studio to two-bedroom units and enjoy amazing amenities!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Salt Lake City, UT",
  "property_seo_description_reviews": "Skyhouse Apartments in Salt Lake City offers modern living with top-notch amenities. Check out resident reviews and see why our community feels like home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Salt Lake City, UT",
  "property_seo_description_applynow": "Discover modern living at Skyhouse Apartments in Salt Lake City! Choose from studio to two-bedroom units and enjoy exclusive amenities.",
  "property_seo_title_residentaccess": "Resident Access | Skyhouse Apartments",
  "property_seo_description_residentaccess": "Log in to your Skyhouse Apartments resident portal in Salt Lake City! Easily pay rent, schedule maintenance, and manage your home all in one place.",
  "property_seo_title_referafriend": "Refer A Friend | Skyhouse Apartments",
  "property_seo_description_referafriend": "Refer a friend to Skyhouse Apartments in Salt Lake City! Great friends make great neighbors—join our vibrant community today and enjoy living together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Skyhouse Apartments",
  "property_seo_description_scheduletour": "Experience the vibrant lifestyle at Skyhouse Apartments in Salt Lake City. Schedule your tour today and see how luxury meets comfort in every corner!",
  "property_seo_title_privacy": "Privacy Policy | Skyhouse Apartments",
  "property_seo_description_privacy": "At Skyhouse Apartments, your privacy matters. Discover how we protect your information in our privacy policy. Trust us in Salt Lake City!",
  "property_seo_title_accessibility": "Website Accessibility | Skyhouse Apartments",
  "property_seo_description_accessibility": "Join Skyhouse Apartments in Salt Lake City for a welcoming online community that prioritizes digital inclusion for all residents!",
  "property_seo_title_sitemap": "Sitemap | Skyhouse Apartments",
  "property_seo_description_sitemap": "Navigate your way through Skyhouse Apartments in Salt Lake City! Find your ideal home with ease by checking out our comprehensive sitemap.",
  "property_seo_title_thankyou": "Thank You | Skyhouse Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Skyhouse Apartments in Salt Lake City! Our team will connect soon to help you find your ideal new home in the clouds.",
  "property_seo_title_pets": "Pet Policy | Apartments in Salt Lake City, UT",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787850193400",
  "amenities": [
    {
      "id": "ec_2bcf38f0f18499538301546b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "yardi",
      "external_id": "128023509",
      "title": "Short Term Lease",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b81a8ddb36ec834396a3c5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "yardi",
      "external_id": "128023507",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5437416a3a205b45e04ea19a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "yardi",
      "external_id": "128023508",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_200efb3ff572be502d605931",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "yardi",
      "external_id": "128023506",
      "title": "Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_98b3607454f9e0c68dcbbc1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "yardi",
      "external_id": "128023505",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5b8e3edcaa94161aa66a06ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "yardi",
      "external_id": "128023503",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bf82eea6f4d4d787adb4c3f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "yardi",
      "external_id": "128023504",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be303d53b0bda8be1e493508",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "yardi",
      "external_id": "128023502",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_060f6ae6b332248d18bf5e39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "yardi",
      "external_id": "128023501",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_c27c19df8cbd018273051f05",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-419a-7350-b998-87b66c7aeb22.webp",
      "image_media": {
        "alt_text": "Rooftop seating area with city views and string lights.",
        "public_id": "01a03428-419a-7350-b998-87b66c7aeb22",
        "storage_key": "property/6767906449167707/01a03428-419a-7350-b998-87b66c7aeb22.webp",
        "width": 2700,
        "height": 1803
      },
      "title": "Community",
      "description": "Enjoy the city skyline from our rooftop lounge, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Rooftop seating area with city views and string lights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00033.jpg"
    },
    {
      "id": "ec_2e2d7ce78516bc4f3cc3cdfd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-6067-747e-a2c0-62d0a69832b6.webp",
      "image_media": {
        "alt_text": "Rooftop patio with a built-in grill, dining table and chairs, string lights, and city skyline views.",
        "public_id": "01a03428-6067-747e-a2c0-62d0a69832b6",
        "storage_key": "property/6767906449167707/01a03428-6067-747e-a2c0-62d0a69832b6.webp",
        "width": 2700,
        "height": 1803
      },
      "title": "Community",
      "description": "Enjoy outdoor living on our rooftop patio, complete with a gourmet grill, comfortable seating, and stunning city and mountain views. Perfect for entertaining guests or relaxing after a long day.",
      "link": "false",
      "alt_text": "Rooftop patio with a built-in grill, dining table and chairs, string lights, and city skyline views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00032.jpg"
    },
    {
      "id": "ec_e51654e0aa58f648bfcfd855",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-61e5-75d0-b854-63372719a046.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with striped seating and string lights.",
        "public_id": "01a03428-61e5-75d0-b854-63372719a046",
        "storage_key": "property/6767906449167707/01a03428-61e5-75d0-b854-63372719a046.webp",
        "width": 2700,
        "height": 1803
      },
      "title": "Community",
      "description": "Enjoy the city views from our elevated rooftop lounge, featuring comfortable seating and ambient string lighting.",
      "link": "false",
      "alt_text": "Rooftop lounge area with striped seating and string lights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00031.jpg"
    },
    {
      "id": "ec_339582e9335bb495149f7dcd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-639b-75cb-ba56-1ca1238f1071.webp",
      "image_media": {
        "alt_text": "Living room with a green tufted sofa, patterned accent chairs, and a coffee table.",
        "public_id": "01a03428-639b-75cb-ba56-1ca1238f1071",
        "storage_key": "property/6767906449167707/01a03428-639b-75cb-ba56-1ca1238f1071.webp",
        "width": 2700,
        "height": 1803
      },
      "title": "Apartment",
      "description": "Relax and unwind in the elegantly designed living room, featuring plush seating and sophisticated decor.",
      "link": "false",
      "alt_text": "Living room with a green tufted sofa, patterned accent chairs, and a coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00015.jpg"
    },
    {
      "id": "ec_7a650323ef4c5f0bbf5c5a35",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-6360-741f-9a87-b1223e8a52e8.webp",
      "image_media": {
        "alt_text": "A stylish living room with emerald green armchairs, a gold geometric coffee table, and decorative bird art.",
        "public_id": "01a03428-6360-741f-9a87-b1223e8a52e8",
        "storage_key": "property/6767906449167707/01a03428-6360-741f-9a87-b1223e8a52e8.webp",
        "width": 1803,
        "height": 2700
      },
      "title": "Apartment",
      "description": "Relax and unwind in the elegant living room, featuring plush seating, a striking gold coffee table, and captivating wall art.",
      "link": "false",
      "alt_text": "A stylish living room with emerald green armchairs, a gold geometric coffee table, and decorative bird art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00020.jpg"
    },
    {
      "id": "ec_57fb7c88125b6558529ac9f0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-67fa-74a2-b92a-91e492cd94c0.webp",
      "image_media": {
        "alt_text": "Lush green seating area with modern art.",
        "public_id": "01a03428-67fa-74a2-b92a-91e492cd94c0",
        "storage_key": "property/6767906449167707/01a03428-67fa-74a2-b92a-91e492cd94c0.webp",
        "width": 2700,
        "height": 1803
      },
      "title": "Community",
      "description": "Enjoy our sophisticated resident lounge, featuring plush green seating, contemporary art, and elegant lighting. Perfect for relaxation or casual meetings.",
      "link": "false",
      "alt_text": "Lush green seating area with modern art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00019.jpg"
    },
    {
      "id": "ec_8145d01a04365c00dd907add",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-76eb-7648-bd04-42a71a038d6d.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with black bar stools and decorative terrarium art.",
        "public_id": "01a03428-76eb-7648-bd04-42a71a038d6d",
        "storage_key": "property/6767906449167707/01a03428-76eb-7648-bd04-42a71a038d6d.webp",
        "width": 1803,
        "height": 2700
      },
      "title": "Apartment",
      "description": "Enjoy breakfast or a quick meal at this sleek kitchen island, featuring stylish bar stools and unique terrarium wall art for a touch of modern elegance.",
      "link": "false",
      "alt_text": "Modern kitchen island with black bar stools and decorative terrarium art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00013.jpg"
    },
    {
      "id": "ec_dbee070a750e32013cde221a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-7c32-720f-8c00-c782f4862cfc.webp",
      "image_media": {
        "alt_text": "Plush black wingback chairs arranged around a coffee table with decorative orbs, under a sparkling crystal chandelier.",
        "public_id": "01a03428-7c32-720f-8c00-c782f4862cfc",
        "storage_key": "property/6767906449167707/01a03428-7c32-720f-8c00-c782f4862cfc.webp",
        "width": 1803,
        "height": 2700
      },
      "title": "Community",
      "description": "Experience elegant comfort in our meticulously designed common areas, featuring plush seating and stunning chandeliers.",
      "link": "false",
      "alt_text": "Plush black wingback chairs arranged around a coffee table with decorative orbs, under a sparkling crystal chandelier.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00017.jpg"
    },
    {
      "id": "ec_8fa691bbe7015e0844e37bd8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-84dd-711b-b4de-6288b139b820.webp",
      "image_media": {
        "alt_text": "Modern dining room with a sleek white table and clear chairs, centered around a fireplace and flat-screen TV.",
        "public_id": "01a03428-84dd-711b-b4de-6288b139b820",
        "storage_key": "property/6767906449167707/01a03428-84dd-711b-b4de-6288b139b820.webp",
        "width": 1803,
        "height": 2700
      },
      "title": "Apartment",
      "description": "Elegant dining area featuring a white table, transparent chairs, a decorative centerpiece, and a fireplace with an above-mounted television, creating a sophisticated ambiance.",
      "link": "false",
      "alt_text": "Modern dining room with a sleek white table and clear chairs, centered around a fireplace and flat-screen TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00012.jpg"
    },
    {
      "id": "ec_0ac945ae0fa3c4290bbc0c25",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-8109-75e3-ba3a-1ac393f85006.webp",
      "image_media": {
        "alt_text": "Chic seating area with plush green sofa, patterned armchairs, and a modern coffee table with decorative items.",
        "public_id": "01a03428-8109-75e3-ba3a-1ac393f85006",
        "storage_key": "property/6767906449167707/01a03428-8109-75e3-ba3a-1ac393f85006.webp",
        "width": 1803,
        "height": 2700
      },
      "title": "Community",
      "description": "Relax in style in our beautifully appointed community lounge, featuring elegant seating and sophisticated decor.",
      "link": "false",
      "alt_text": "Chic seating area with plush green sofa, patterned armchairs, and a modern coffee table with decorative items.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00016.jpg"
    },
    {
      "id": "ec_7a92ce1f1cbee84621d98eab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-8309-745d-96b5-9295480bb3df.webp",
      "image_media": {
        "alt_text": "Modern living area with fireplace and open kitchen.",
        "public_id": "01a03428-8309-745d-96b5-9295480bb3df",
        "storage_key": "property/6767906449167707/01a03428-8309-745d-96b5-9295480bb3df.webp",
        "width": 2700,
        "height": 1803
      },
      "title": "Community",
      "description": "Stylish communal lounge featuring a fireplace, comfortable seating, and an adjacent modern kitchen with bar seating.",
      "link": "false",
      "alt_text": "Modern living area with fireplace and open kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00018.jpg"
    },
    {
      "id": "ec_283615fa781efbe45f2ad210",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-96ab-7052-88dc-f620e38b8888.webp",
      "image_media": {
        "alt_text": "Elegant lounge area with a fireplace, TV, dining table, and seating.",
        "public_id": "01a03428-96ab-7052-88dc-f620e38b8888",
        "storage_key": "property/6767906449167707/01a03428-96ab-7052-88dc-f620e38b8888.webp",
        "width": 2700,
        "height": 1803
      },
      "title": "Community",
      "description": "Experience the sophisticated lounge and dining area, featuring a cozy fireplace and elegant seating arrangements.",
      "link": "false",
      "alt_text": "Elegant lounge area with a fireplace, TV, dining table, and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00014.jpg"
    },
    {
      "id": "ec_0534e0e88a019d4778aa877f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-a270-74d3-a41d-088356d4d1ad.webp",
      "image_media": {
        "alt_text": "Modern kitchen with sleek grey cabinetry, white quartz countertops, stainless steel appliances, and gold bar stools.",
        "public_id": "01a03428-a270-74d3-a41d-088356d4d1ad",
        "storage_key": "property/6767906449167707/01a03428-a270-74d3-a41d-088356d4d1ad.webp",
        "width": 1803,
        "height": 2700
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this stylish, modern kitchen featuring ample counter space, high-end appliances, and a chic breakfast bar with comfortable seating.",
      "link": "false",
      "alt_text": "Modern kitchen with sleek grey cabinetry, white quartz countertops, stainless steel appliances, and gold bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00011.jpg"
    },
    {
      "id": "ec_99e887614a9b2d6f105f82c4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-9c08-7410-a98a-bf9b1029687c.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with seating and city views.",
        "public_id": "01a03428-9c08-7410-a98a-bf9b1029687c",
        "storage_key": "property/6767906449167707/01a03428-9c08-7410-a98a-bf9b1029687c.webp",
        "width": 2700,
        "height": 1803
      },
      "title": "Community",
      "description": "Enjoy the city skyline from our rooftop lounge, featuring comfortable seating and ambient lighting.",
      "link": "false",
      "alt_text": "Rooftop lounge area with seating and city views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00001.jpg"
    },
    {
      "id": "ec_d48385699b8faebfc3d58c42",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-a0b3-756e-ac32-c094c2e69c1c.webp",
      "image_media": {
        "alt_text": "Modern living room with pink sofa, teal curtains, and decorative rug.",
        "public_id": "01a03428-a0b3-756e-ac32-c094c2e69c1c",
        "storage_key": "property/6767906449167707/01a03428-a0b3-756e-ac32-c094c2e69c1c.webp",
        "width": 2700,
        "height": 1803
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a plush pink sofa, vibrant teal curtains, a patterned rug, and modern furniture, creating a chic and inviting atmosphere.",
      "link": "false",
      "alt_text": "Modern living room with pink sofa, teal curtains, and decorative rug.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00005.jpg"
    },
    {
      "id": "ec_3a27a5a5e55af1fa01db0cbd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-a4d6-703e-bf29-db7c3f151c8e.webp",
      "image_media": {
        "alt_text": "A light pink couch with a pink pillow and yellow throw blanket, next to a side table with a lamp and monkey statue.",
        "public_id": "01a03428-a4d6-703e-bf29-db7c3f151c8e",
        "storage_key": "property/6767906449167707/01a03428-a4d6-703e-bf29-db7c3f151c8e.webp",
        "width": 1803,
        "height": 2700
      },
      "title": "Apartment",
      "description": "Relax in style with this comfortable and chic living room setup, featuring a plush pink couch and unique decorative accents.",
      "link": "false",
      "alt_text": "A light pink couch with a pink pillow and yellow throw blanket, next to a side table with a lamp and monkey statue.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00003.jpg"
    },
    {
      "id": "ec_b0b0bccb6f6cca1f1d0cf295",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-ae5c-71e9-b50f-05376c264b02.webp",
      "image_media": {
        "alt_text": "Close-up of a stylish bedroom with a blue tufted headboard, white linens, and abstract art above a nightstand.",
        "public_id": "01a03428-ae5c-71e9-b50f-05376c264b02",
        "storage_key": "property/6767906449167707/01a03428-ae5c-71e9-b50f-05376c264b02.webp",
        "width": 1803,
        "height": 2700
      },
      "title": "Apartment",
      "description": "Elegant bedroom featuring a luxurious blue velvet headboard and crisp white bedding, complemented by a striking abstract artwork and a modern nightstand with decorative accents.",
      "link": "false",
      "alt_text": "Close-up of a stylish bedroom with a blue tufted headboard, white linens, and abstract art above a nightstand.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00009.jpg"
    },
    {
      "id": "ec_326a736ebc1109e1913c04e9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-b8bf-719d-96dd-4f32699f694f.webp",
      "image_media": {
        "alt_text": "Stylish living room with a pink sofa, decorative pillows, and art.",
        "public_id": "01a03428-b8bf-719d-96dd-4f32699f694f",
        "storage_key": "property/6767906449167707/01a03428-b8bf-719d-96dd-4f32699f694f.webp",
        "width": 1803,
        "height": 2700
      },
      "title": "Apartment",
      "description": "Discover sophisticated living in our beautifully appointed apartments, featuring elegant decor and comfortable furnishings.",
      "link": "false",
      "alt_text": "Stylish living room with a pink sofa, decorative pillows, and art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00004.jpg"
    },
    {
      "id": "ec_e11a63a4d25d700de5560c16",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-bb18-7274-91bc-e407de857832.webp",
      "image_media": {
        "alt_text": "A stylish navy blue nightstand with gold hardware next to a bed with floral bedding and a white carved headboard.",
        "public_id": "01a03428-bb18-7274-91bc-e407de857832",
        "storage_key": "property/6767906449167707/01a03428-bb18-7274-91bc-e407de857832.webp",
        "width": 1803,
        "height": 2700
      },
      "title": "Apartment",
      "description": "Stylish navy blue nightstand with gold hardware and decorative items, adjacent to a bed featuring vibrant floral bedding and a decorative white headboard, creating a chic bedroom aesthetic.",
      "link": "false",
      "alt_text": "A stylish navy blue nightstand with gold hardware next to a bed with floral bedding and a white carved headboard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00010.jpg"
    },
    {
      "id": "ec_c195e806e56bc837629e03b9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-c258-7000-a15f-b1340cdf66d2.webp",
      "image_media": {
        "alt_text": "A pink sofa with decorative pillows sits in front of teal curtains.",
        "public_id": "01a03428-c258-7000-a15f-b1340cdf66d2",
        "storage_key": "property/6767906449167707/01a03428-c258-7000-a15f-b1340cdf66d2.webp",
        "width": 1803,
        "height": 2700
      },
      "title": "Apartment",
      "description": "Elegant pink sofa with stylish decorative pillows, set against a backdrop of luxurious teal curtains and a bright window. Perfect for a modern living space.",
      "link": "false",
      "alt_text": "A pink sofa with decorative pillows sits in front of teal curtains.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00006.jpg"
    },
    {
      "id": "ec_31959ffb656940680632717a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-be32-725a-9334-e8f08708e135.webp",
      "image_media": {
        "alt_text": "A plush blue headboard and a bedside table with a lamp and decor.",
        "public_id": "01a03428-be32-725a-9334-e8f08708e135",
        "storage_key": "property/6767906449167707/01a03428-be32-725a-9334-e8f08708e135.webp",
        "width": 1803,
        "height": 2700
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a plush blue tufted headboard, a sleek bedside table with a chrome lamp, decorative pillows, and abstract art.",
      "link": "false",
      "alt_text": "A plush blue headboard and a bedside table with a lamp and decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00007.jpg"
    },
    {
      "id": "ec_769804c3d8a4591fc635d773",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-c7fc-71cd-a1b3-f4b262e21efa.webp",
      "image_media": {
        "alt_text": "Stylish living room with a pink sofa, glass coffee table, and floral rug.",
        "public_id": "01a03428-c7fc-71cd-a1b3-f4b262e21efa",
        "storage_key": "property/6767906449167707/01a03428-c7fc-71cd-a1b3-f4b262e21efa.webp",
        "width": 1803,
        "height": 2700
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed living space, featuring a plush pink sofa, a modern glass coffee table, and a vibrant floral rug.",
      "link": "false",
      "alt_text": "Stylish living room with a pink sofa, glass coffee table, and floral rug.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00002.jpg"
    },
    {
      "id": "ec_9bae3e45b52824d8834be6e5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a03428-d163-70f4-aed4-0d8ce2756c46.webp",
      "image_media": {
        "alt_text": "Nightstand with a lamp, art, and decorative items next to a blue velvet headboard.",
        "public_id": "01a03428-d163-70f4-aed4-0d8ce2756c46",
        "storage_key": "property/6767906449167707/01a03428-d163-70f4-aed4-0d8ce2756c46.webp",
        "width": 1803,
        "height": 2700
      },
      "title": "Apartment",
      "description": "Elegant nightstand featuring a sleek lamp, abstract art, and stylish decor, adjacent to a luxurious blue velvet headboard, creating a chic bedroom aesthetic.",
      "link": "false",
      "alt_text": "Nightstand with a lamp, art, and decorative items next to a blue velvet headboard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93519/Skyhouse Apartments Downtown Salt Lake City00008.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_1c29b6e7-0fbc-4639-a828-25fdeb79925e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Eva's Bakery",
      "poi_type": "Restaurants",
      "poi_address": "155 S Main St, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Cheery bakeshop using area-sourced flour to make bread, French pastries, sandwiches & more.",
      "poi_long_description": "Cheery bakeshop using area-sourced flour to make bread, French pastries, sandwiches & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-3816-73a8-b500-2fb4782c488a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-3816-73a8-b500-2fb4782c488a",
        "storage_key": "property/6767906449167707/01a01ae9-3816-73a8-b500-2fb4782c488a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.evasbakeryslc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=605027636689835387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "evas-bakery",
      "poi_latitude": "40.7657866",
      "poi_longitude": "-111.8908379",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-355-3942",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df5-72a5-861b-8e169b841024",
        "storage_key": "property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCUw0DQ_1UocRexUxFG59ZQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_74b7dcc6-0994-4857-b097-d55b1ec4d40e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "The Rose Establishment",
      "poi_type": "Restaurants",
      "poi_address": "235 400 W, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Hip, down-home coffeehouse with exotic beans & loose-leaf tea, plus in-house bakery & sandwich menu.",
      "poi_long_description": "Hip, down-home coffeehouse with exotic beans & loose-leaf tea, plus in-house bakery & sandwich menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-3559-776a-8fae-63e035041034.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-3559-776a-8fae-63e035041034",
        "storage_key": "property/6767906449167707/01a01ae9-3559-776a-8fae-63e035041034.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.theroseestb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1457275926377065433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-rose-establishment",
      "poi_latitude": "40.7640643",
      "poi_longitude": "-111.9022248",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 801-208-5569",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-7ff2-70b0-93b7-edf395bfc429.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae9-7ff2-70b0-93b7-edf395bfc429",
        "storage_key": "property/6767906449167707/01a01ae9-7ff2-70b0-93b7-edf395bfc429.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJbTfERwL1UocR2etu67tIORQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_be6588d0-cea2-4554-b5e0-66c7e8066af9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Takashi",
      "poi_type": "Restaurants",
      "poi_address": "18 W Market St, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Japanese eatery & sushi bar featuring signature rolls & a big sake list in hip, contemporary digs.",
      "poi_long_description": "Japanese eatery & sushi bar featuring signature rolls & a big sake list in hip, contemporary digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-30fd-769f-8a20-0d87f80829fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-30fd-769f-8a20-0d87f80829fb",
        "storage_key": "property/6767906449167707/01a01ae9-30fd-769f-8a20-0d87f80829fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://takashisushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3530387266263894461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "takashi",
      "poi_latitude": "40.7618319",
      "poi_longitude": "-111.8918702",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-519-9595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df5-72a5-861b-8e169b841024",
        "storage_key": "property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJySRBGhD1UocRvck4jYN0_jA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_659a296f-0fde-48f4-b120-ea3f720b4448",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "The Copper Onion",
      "poi_type": "Restaurants",
      "poi_address": "111 E Broadway #170, Salt Lake City, UT 84111, USA",
      "poi_short_description": "Locally sourced New American fare, cocktails, and brunch in a modern setting.",
      "poi_long_description": "Locally sourced New American fare, cocktails, and brunch in a modern setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-32a5-77dd-8c3d-71d65d121eea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-32a5-77dd-8c3d-71d65d121eea",
        "storage_key": "property/6767906449167707/01a01ae9-32a5-77dd-8c3d-71d65d121eea.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://thecopperonion.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1180221363442922443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-copper-onion",
      "poi_latitude": "40.7630797",
      "poi_longitude": "-111.8872299",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 801-355-3282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df5-72a5-861b-8e169b841024",
        "storage_key": "property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrS_p5hH1UocRy7NXtBP9YBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_46cdfd2d-a616-4d99-9d1b-c94c013ecbcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Fleming’s Prime Steakhouse & Wine Bar",
      "poi_type": "Restaurants",
      "poi_address": "20 S 400 W #2020, Salt Lake City, UT 84101, USA",
      "poi_short_description": "High-end steakhouse chain with aged prime beef & classics such as lobster tails.",
      "poi_long_description": "High-end steakhouse chain with aged prime beef & classics such as lobster tails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-178a-76db-a19a-89d8491eea83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-178a-76db-a19a-89d8491eea83",
        "storage_key": "property/6767906449167707/01a0253b-178a-76db-a19a-89d8491eea83.webp",
        "width": 1280,
        "height": 860
      },
      "poi_business_url": "https://www.flemingssteakhouse.com/Locations/UT/Salt-Lake-City?y_source=1_MTU1MDMxNTctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13135018306894542984&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flemings-prime-steakhouse--wine-bar",
      "poi_latitude": "40.7687399",
      "poi_longitude": "-111.9033043",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 801-355-3704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df5-72a5-861b-8e169b841024",
        "storage_key": "property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4WOPtgH1UocRiLizzI71SLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_464eeee1-b3f5-4b8f-99a2-a18c71cca5a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Red Rock Brewing - Downtown Salt Lake City",
      "poi_type": "Restaurants",
      "poi_address": "254 S 200 W, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Celebrated local brewery selling cold & fresh beer directly to the public.",
      "poi_long_description": "Celebrated local brewery selling cold & fresh beer directly to the public.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-3559-776a-8fae-5cee9ecbf69f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-3559-776a-8fae-5cee9ecbf69f",
        "storage_key": "property/6767906449167707/01a01ae9-3559-776a-8fae-5cee9ecbf69f.webp",
        "width": 1280,
        "height": 828
      },
      "poi_business_url": "https://redrockbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3583511463639954625&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-rock-brewing---downtown-salt-lake-city",
      "poi_latitude": "40.763648",
      "poi_longitude": "-111.89724",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 435-409-4089",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df5-72a5-861b-8e169b841024",
        "storage_key": "property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZeGm9AT1UocRwbTMnrAwuzE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_45d8ebdc-d513-4623-81e4-402a39623a36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Settebello Pizzeria Napoletana",
      "poi_type": "Restaurants",
      "poi_address": "260 S 200 W, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Casual spot offering handmade Neapolitan pizzas fired in a wood-burning oven the old-fashioned way.",
      "poi_long_description": "Casual spot offering handmade Neapolitan pizzas fired in a wood-burning oven the old-fashioned way.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-2e56-778b-a7ff-c9e10bf0f78d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-2e56-778b-a7ff-c9e10bf0f78d",
        "storage_key": "property/6767906449167707/01a01ae9-2e56-778b-a7ff-c9e10bf0f78d.webp",
        "width": 820,
        "height": 350
      },
      "poi_business_url": "http://settebello.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12007428317260851680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "settebello-pizzeria-napoletana",
      "poi_latitude": "40.7634871",
      "poi_longitude": "-111.8970853",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 801-322-3556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df5-72a5-861b-8e169b841024",
        "storage_key": "property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf7EcjQT1UocR4KlMvG_0oqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_e98bb4db-e5c7-4aa3-af3e-b5e00cd47d2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Taqueria 27 Downtown",
      "poi_type": "Restaurants",
      "poi_address": "149 E 200 S, Salt Lake City, UT 84111, USA",
      "poi_short_description": "Tacos including fish and pork belly are served alongside margaritas, beer, and wine in a trendy setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-2e79-7290-9cf0-d860dcddc59c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-2e79-7290-9cf0-d860dcddc59c",
        "storage_key": "property/6767906449167707/01a01ae9-2e79-7290-9cf0-d860dcddc59c.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://taqueria27.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10719974512609472368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taqueria-27-downtown",
      "poi_latitude": "40.7652726",
      "poi_longitude": "-111.8863843",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 385-259-0940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df5-72a5-861b-8e169b841024",
        "storage_key": "property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMQQ_2Q31UocRcC9UuQUAxZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "custom_eda1b43b-e9ba-42c4-8b03-bdfb39289d35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Crown Burgers",
      "poi_type": "Restaurants",
      "poi_address": "118 N 300 W, Salt Lake City, UT 84103, USA",
      "poi_short_description": "Local fast-food chain serving signature pastrami-topped burgers, gyros & other Greek eats.",
      "poi_long_description": "Local fast-food chain serving signature pastrami-topped burgers, gyros & other Greek eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-3374-74b9-af75-6ac17ca4213c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-3374-74b9-af75-6ac17ca4213c",
        "storage_key": "property/6767906449167707/01a01ae9-3374-74b9-af75-6ac17ca4213c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://crownburgers.zazdelivery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2393408604564285355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crown-burgers",
      "poi_latitude": "40.77211670000001",
      "poi_longitude": "-111.8992444",
      "poi_miles_from_property": "0.07",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 801-532-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df5-72a5-861b-8e169b841024",
        "storage_key": "property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD-IrIqr1UocRq-dq7XEYNyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_e947936e-103f-4208-b7c8-136d0c2a802b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Red Iguana",
      "poi_type": "Restaurants",
      "poi_address": "736 W North Temple St, Salt Lake City, UT 84116, USA",
      "poi_short_description": "Bustling, family-run Mexican cafe serving signature mole plus traditional & gluten-free favorites.",
      "poi_long_description": "Bustling, family-run Mexican cafe serving signature mole plus traditional & gluten-free favorites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-531b-7134-871c-763ca6b9f2e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae6-531b-7134-871c-763ca6b9f2e5",
        "storage_key": "property/6767906449167707/01a01ae6-531b-7134-871c-763ca6b9f2e5.webp",
        "width": 1280,
        "height": 948
      },
      "poi_business_url": "https://www.rediguana.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11516129657914646960&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-iguana",
      "poi_latitude": "40.7718053",
      "poi_longitude": "-111.9124897",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 801-322-1489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df5-72a5-861b-8e169b841024",
        "storage_key": "property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm_zJw1b0UocRsOFXp-iC0Z8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_d1dd7122-c2e2-4060-a95e-b839741d8870",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Nico's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1458 W North Temple St, Salt Lake City, UT 84116, USA",
      "poi_short_description": "Enchiladas, chile rellenos, and other traditional Mexican dishes served in a relaxed atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-1d20-770b-9359-3d4fc9b8e71c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-1d20-770b-9359-3d4fc9b8e71c",
        "storage_key": "property/6767906449167707/01a0253b-1d20-770b-9359-3d4fc9b8e71c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nicos-restaurant.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=447489965248645429&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nicos-restaurant",
      "poi_latitude": "40.7718086",
      "poi_longitude": "-111.9328969",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 801-364-0363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df5-72a5-861b-8e169b841024",
        "storage_key": "property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPVz2XWb0UocRNYkyo8DNNQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_dd55c053-97ca-4d8e-88fc-3623266f46c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Squatters Pub Brewery Downtown SLC",
      "poi_type": "Restaurants",
      "poi_address": "147 W Broadway, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Flagship of a relaxed microbrewery chain crafting seasonal & year-round beers & eclectic pub grub.",
      "poi_long_description": "Flagship of a relaxed microbrewery chain crafting seasonal & year-round beers & eclectic pub grub.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-2f1a-7309-9666-1b71aa8d1aa2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-2f1a-7309-9666-1b71aa8d1aa2",
        "storage_key": "property/6767906449167707/01a01ae9-2f1a-7309-9666-1b71aa8d1aa2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.squatterspubs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=267932068772635277&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "squatters-pub-brewery-downtown-slc",
      "poi_latitude": "40.7625231",
      "poi_longitude": "-111.8956578",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 801-363-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df5-72a5-861b-8e169b841024",
        "storage_key": "property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG_1NJgX1UocRjeIgB8zitwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "custom_187756be-63f5-4980-bd4d-f17e21d40052",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Current Fish and Oyster",
      "poi_type": "Restaurants",
      "poi_address": "279 E 300 S, Salt Lake City, UT 84111, USA",
      "poi_short_description": "Industrial-chic bar & eatery offering regional, sustainable seafood plates in a historic building.",
      "poi_long_description": "Industrial-chic bar & eatery offering regional, sustainable seafood plates in a historic building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-1776-7248-8854-915bc57fd79a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-1776-7248-8854-915bc57fd79a",
        "storage_key": "property/6767906449167707/01a0253b-1776-7248-8854-915bc57fd79a.webp",
        "width": 750,
        "height": 568
      },
      "poi_business_url": "https://www.currentfishandoyster.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16459791606718121793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "current-fish-and-oyster",
      "poi_latitude": "40.7631675",
      "poi_longitude": "-111.8828652",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df5-72a5-861b-8e169b841024",
        "storage_key": "property/6767906449167707/01a01ae6-7df5-72a5-861b-8e169b841024.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__9r8hL1UocRQcdjM0LtbOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_cc3780af-9985-4368-a1dc-faceebce1526",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Fisher Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "320 W 800 S, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Community brewery & taproom serving ales, lagers & eats from local food trucks.",
      "poi_long_description": "Community brewery & taproom serving ales, lagers & eats from local food trucks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-1cbc-715e-b236-5a29c70c90bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-1cbc-715e-b236-5a29c70c90bd",
        "storage_key": "property/6767906449167707/01a0253b-1cbc-715e-b236-5a29c70c90bd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.fisherbeer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1148183455768953072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fisher-brewing-company",
      "poi_latitude": "40.752157",
      "poi_longitude": "-111.9004478",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-487-2337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-b5a8cad546bb",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWUYraR_1UocR8MAWCsUq7w8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_3acf5064-9c14-4c47-8245-8b188be63f58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Bodega Convenience and Smoke",
      "poi_type": "Shopping & Retail",
      "poi_address": "205 W 400 S, Salt Lake City, UT 84101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-1d27-7522-97e0-4a3345f62e46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-1d27-7522-97e0-4a3345f62e46",
        "storage_key": "property/6767906449167707/01a0253b-1d27-7522-97e0-4a3345f62e46.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=907463894451026150&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bodega-convenience-and-smoke",
      "poi_latitude": "40.7602847",
      "poi_longitude": "-111.8974362",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 385-419-0789",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-7ff1-77eb-9f9f-62a5abe4cd57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae9-7ff1-77eb-9f9f-62a5abe4cd57",
        "storage_key": "property/6767906449167707/01a01ae9-7ff1-77eb-9f9f-62a5abe4cd57.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJWc55dQD1UocR5vg-o5r1lww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_cfd09df6-81fb-4fec-99e1-909b0eb84274",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Market On Main Street",
      "poi_type": "Shopping & Retail",
      "poi_address": "268 S Main St, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Quick-visit convenience store supplying a range of items, including groceries and electronics.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-1bcd-740b-a78f-0f64a57e8869.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-1bcd-740b-a78f-0f64a57e8869",
        "storage_key": "property/6767906449167707/01a0253b-1bcd-740b-a78f-0f64a57e8869.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6073108886920410081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "market-on-main-street",
      "poi_latitude": "40.76329700000001",
      "poi_longitude": "-111.8913337",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-738-2429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-7ff1-77eb-9f9f-62a5abe4cd57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae9-7ff1-77eb-9f9f-62a5abe4cd57",
        "storage_key": "property/6767906449167707/01a01ae9-7ff1-77eb-9f9f-62a5abe4cd57.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJmzwS7w_1UocR4bMoH1sESFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_63a955ae-5ca0-4bb2-9afb-5ce22e04e38f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Harmons Grocery - City Creek",
      "poi_type": "Shopping & Retail",
      "poi_address": "135 E 100 S, Salt Lake City, UT 84111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-3c15-71cd-9d1e-3c4ec8461db0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-3c15-71cd-9d1e-3c4ec8461db0",
        "storage_key": "property/6767906449167707/01a01ae9-3c15-71cd-9d1e-3c4ec8461db0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.harmonsgrocery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2554936648918257932&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harmons-grocery---city-creek",
      "poi_latitude": "40.7678044",
      "poi_longitude": "-111.8874176",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-428-0366",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-bc8db8868ce6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-bc8db8868ce6",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-bc8db8868ce6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_AYog71UocRDFFmdlj1dCM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_77c3e2d0-2ab8-4588-8b08-c703436bbdd2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "634 E 400 S, Salt Lake City, UT 84102, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-4630-7396-acba-eb6c91609027.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae6-4630-7396-acba-eb6c91609027",
        "storage_key": "property/6767906449167707/01a01ae6-4630-7396-acba-eb6c91609027.webp",
        "width": 1280,
        "height": 847
      },
      "poi_business_url": "https://locations.traderjoes.com/ut/salt-lake-city/350/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1822967084851718382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "40.7596942",
      "poi_longitude": "-111.8725988",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-359-2462",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-bc8db8868ce6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-bc8db8868ce6",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-bc8db8868ce6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIymmPmn1UocR7ujQued6TBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_48d9c5c2-4190-4b44-bd94-249ca50f57e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "544 S 700 E, Salt Lake City, UT 84102, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-409b-774f-85ac-bc7a57b53b8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-409b-774f-85ac-bc7a57b53b8f",
        "storage_key": "property/6767906449167707/01a01ae9-409b-774f-85ac-bc7a57b53b8f.webp",
        "width": 1280,
        "height": 947
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/trolleysquare?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=12820008217300887563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "40.757911",
      "poi_longitude": "-111.8719498",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 801-924-9060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-bc8db8868ce6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-bc8db8868ce6",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-bc8db8868ce6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMyAHO2n1UocRC-jO4YzR6bE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_bd3511a2-84cd-4d45-ae87-de01df6526c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Smith's",
      "poi_type": "Shopping & Retail",
      "poi_address": "455 E 500 S, Salt Lake City, UT 84102, USA",
      "poi_short_description": "Typical supermaket carrying produce, meat & pantry staples, along with beer & liquor.",
      "poi_long_description": "Typical supermaket carrying produce, meat & pantry staples, along with beer & liquor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-1f87-70ee-a363-8a198432dd77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-1f87-70ee-a363-8a198432dd77",
        "storage_key": "property/6767906449167707/01a0253b-1f87-70ee-a363-8a198432dd77.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.smithsfoodanddrug.com/stores/grocery/ut/salt-lake-city/455-s-500-e-slc-ut/706/00094?cid=loc_70600094_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=18275002783151859842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smiths",
      "poi_latitude": "40.7593183",
      "poi_longitude": "-111.8752518",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-328-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-bc8db8868ce6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-bc8db8868ce6",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-bc8db8868ce6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1YR3umv1UocRgqgKxzTanf0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5ab82803-5669-4ad3-b85e-be8e8c6b8b22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "City Creek Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "50 S Main St, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Upmarket retailers & diverse, casual dining options in polished surrounds with a water fountain.",
      "poi_long_description": "Upmarket retailers & diverse, casual dining options in polished surrounds with a water fountain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-4541-717c-9445-6c8090155d43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae6-4541-717c-9445-6c8090155d43",
        "storage_key": "property/6767906449167707/01a01ae6-4541-717c-9445-6c8090155d43.webp",
        "width": 512,
        "height": 288
      },
      "poi_business_url": "https://shopcitycreekcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1429749320349744761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-creek-center",
      "poi_latitude": "40.76835699999999",
      "poi_longitude": "-111.8917171",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 801-521-2012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dfd-718b-abc9-d861fa053e7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dfd-718b-abc9-d861fa053e7e",
        "storage_key": "property/6767906449167707/01a01ae6-7dfd-718b-abc9-d861fa053e7e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqVbctwj1UocReX5NhW591xM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_3d7321b6-f798-4a89-97f5-3d7d85886668",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "The Gateway",
      "poi_type": "Shopping & Retail",
      "poi_address": "400 W 200 S, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Clothing chain with trendy apparel, shoes & accessories for teen girls & young women.",
      "poi_long_description": "Clothing chain with trendy apparel, shoes & accessories for teen girls & young women.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-3fd2-7171-b21e-2ae8caa19b14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-3fd2-7171-b21e-2ae8caa19b14",
        "storage_key": "property/6767906449167707/01a01ae9-3fd2-7171-b21e-2ae8caa19b14.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://atthegateway.com/?y_source=1_MTg3MjA4MTAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13784244080412223823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-gateway",
      "poi_latitude": "40.7686366",
      "poi_longitude": "-111.903931",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 801-456-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dfd-718b-abc9-d861fa053e7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dfd-718b-abc9-d861fa053e7e",
        "storage_key": "property/6767906449167707/01a01ae6-7dfd-718b-abc9-d861fa053e7e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBeG1IwD1UocRT2lAhvV4S78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_63421f3f-67d9-4518-b846-81ca13848125",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "531 E 400 S, Salt Lake City, UT 84102, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-236e-768f-a988-dadb2b3f8632.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-236e-768f-a988-dadb2b3f8632",
        "storage_key": "property/6767906449167707/01a0253b-236e-768f-a988-dadb2b3f8632.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-531+e+400+s-salt+lake+city-ut-84102/id=9238",
      "poi_directions_map_url": "https://maps.google.com/?cid=17912196602971906505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "40.76123990000001",
      "poi_longitude": "-111.8756448",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-478-0703",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-b5a8cad546bb",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsXgmCWz1UocRyWEZU-jnlPg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_3c35155a-a8b6-4ed0-a576-db5b3e96e9bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Trolley Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "602 E 500 S, Salt Lake City, UT 84102, USA",
      "poi_short_description": "1900s trolley barn turned upscale mall with chain stores & local boutiques, restaurants & a museum.",
      "poi_long_description": "1900s trolley barn turned upscale mall with chain stores & local boutiques, restaurants & a museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-2239-743a-a3e2-b5469cbe48e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-2239-743a-a3e2-b5469cbe48e0",
        "storage_key": "property/6767906449167707/01a0253b-2239-743a-a3e2-b5469cbe48e0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.trolleysquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12255476910402983304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trolley-square",
      "poi_latitude": "40.7572935",
      "poi_longitude": "-111.8722972",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-521-9877",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dfd-718b-abc9-d861fa053e7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dfd-718b-abc9-d861fa053e7e",
        "storage_key": "property/6767906449167707/01a01ae6-7dfd-718b-abc9-d861fa053e7e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJRed-d0L1UocRiFWSVVEzFKo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f0048d8e-0b5c-441c-b088-ea2d692b0d26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Open Classroom",
      "poi_type": "Education",
      "poi_address": "134 D St E, Salt Lake City, UT 84103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-4168-758c-9019-d2cabe0cff98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-4168-758c-9019-d2cabe0cff98",
        "storage_key": "property/6767906449167707/01a01ae9-4168-758c-9019-d2cabe0cff98.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.ocslc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12092186503929300496&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "open-classroom",
      "poi_latitude": "40.7725531",
      "poi_longitude": "-111.8785665",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 801-578-8144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd7-7630-9ec4-6171e2e70567",
        "storage_key": "property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO3lNHnX1UocREIZ65I4T0Kc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_1c944d39-1f52-4e01-ab1b-894c0339ddd3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Wasatch Elementary School",
      "poi_type": "Education",
      "poi_address": "30 R St, Salt Lake City, UT 84103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-255b-7445-8976-01a7df704d8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-255b-7445-8976-01a7df704d8a",
        "storage_key": "property/6767906449167707/01a0253b-255b-7445-8976-01a7df704d8a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://wasatch.slcschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4330121839268720531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wasatch-elementary-school",
      "poi_latitude": "40.7700803",
      "poi_longitude": "-111.8575336",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-578-8564",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd7-7630-9ec4-6171e2e70567",
        "storage_key": "property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCXeaRn31UocRk-_F796uFzw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_5a878f55-33e2-4406-9981-051de4b4364b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "West High School",
      "poi_type": "Education",
      "poi_address": "241 N 300 W, Salt Lake City, UT 84103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-2502-71e8-a1b0-7b5ab6c90b05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-2502-71e8-a1b0-7b5ab6c90b05",
        "storage_key": "property/6767906449167707/01a0253b-2502-71e8-a1b0-7b5ab6c90b05.webp",
        "width": 1280,
        "height": 684
      },
      "poi_business_url": "http://west.slcschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16548334118332288844&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-high-school",
      "poi_latitude": "40.7748279",
      "poi_longitude": "-111.9002715",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 801-578-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd7-7630-9ec4-6171e2e70567",
        "storage_key": "property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_biQTKr1UocRTE-sKzR-p-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_30bd6ecf-67c5-4ec2-8791-995b7217d69b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Ensign College",
      "poi_type": "Education",
      "poi_address": "95 N 300 W, Salt Lake City, UT 84101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-4c5b-75dd-9676-eb6acbfd694d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae6-4c5b-75dd-9676-eb6acbfd694d",
        "storage_key": "property/6767906449167707/01a01ae6-4c5b-75dd-9676-eb6acbfd694d.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.ensign.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13914062519158002785&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ensign-college",
      "poi_latitude": "40.7711865",
      "poi_longitude": "-111.9002464",
      "poi_miles_from_property": "0.06",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 801-524-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd7-7630-9ec4-6171e2e70567",
        "storage_key": "property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ45sdcqr1UocRYVT9LCSuGME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_60865068-baf4-4da6-9650-e0f0e55eb361",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "City Academy",
      "poi_type": "Education",
      "poi_address": "555 E 200 S, Salt Lake City, UT 84102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-2580-767b-97a7-3d4d727b7c16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-2580-767b-97a7-3d4d727b7c16",
        "storage_key": "property/6767906449167707/01a0253b-2580-767b-97a7-3d4d727b7c16.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cityacademyslc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6447416963453576161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-academy",
      "poi_latitude": "40.765311",
      "poi_longitude": "-111.8748909",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 801-596-8489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd7-7630-9ec4-6171e2e70567",
        "storage_key": "property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJffk__W31UocR4WN6gZHTeVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_8fe875ed-68e2-4052-af6c-dca307ce41a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Pinyon Montessori",
      "poi_type": "Education",
      "poi_address": "Arbor 515, 515 E 100 S #200, Salt Lake City, UT 84102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-2685-7629-b944-d9ebf4130ad0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-2685-7629-b944-d9ebf4130ad0",
        "storage_key": "property/6767906449167707/01a0253b-2685-7629-b944-d9ebf4130ad0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://pinyonmontessori.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11077521396063573810&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinyon-montessori",
      "poi_latitude": "40.7675563",
      "poi_longitude": "-111.8761493",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 385-955-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd7-7630-9ec4-6171e2e70567",
        "storage_key": "property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn0NzsVX1UocRMpcovARDu5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_73d5a2ed-315f-419e-820b-f99553f8a53a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Miss Billie's Kids Kampus",
      "poi_type": "Education",
      "poi_address": "232 W 800 S, Salt Lake City, UT 84101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-2bab-72eb-b9d9-45b17cd23b1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-2bab-72eb-b9d9-45b17cd23b1e",
        "storage_key": "property/6767906449167707/01a0253b-2bab-72eb-b9d9-45b17cd23b1e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1822655918390221918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miss-billies-kids-kampus",
      "poi_latitude": "40.7523589",
      "poi_longitude": "-111.897876",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 801-322-5683",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd7-7630-9ec4-6171e2e70567",
        "storage_key": "property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn5yHrxj1UocRXpxpo-ZfSxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_34e0cd3e-efa3-4a6c-90a9-085edf164f08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Lolie Eccles Early Education Center",
      "poi_type": "Education",
      "poi_address": "344 E 300 S, Salt Lake City, UT 84111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-2acd-77da-83ab-d000b88d733e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-2acd-77da-83ab-d000b88d733e",
        "storage_key": "property/6767906449167707/01a0253b-2acd-77da-83ab-d000b88d733e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://ywcautahearlyed.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17998669387742522865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lolie-eccles-early-education-center",
      "poi_latitude": "40.7625532",
      "poi_longitude": "-111.8807439",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-537-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd7-7630-9ec4-6171e2e70567",
        "storage_key": "property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8xoA0xL1UocR8S0XdnIeyPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_3a3f7aa1-d7a5-4106-8ef4-2a0a460c5476",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Salt Lake Center for Science Education",
      "poi_type": "Education",
      "poi_address": "1400 Goodwin Ave, Salt Lake City, UT 84116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-4441-77e0-ba8e-9534deac4a87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-4441-77e0-ba8e-9534deac4a87",
        "storage_key": "property/6767906449167707/01a01ae9-4441-77e0-ba8e-9534deac4a87.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://slcse.slcschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15659647355356061502&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salt-lake-center-for-science-education",
      "poi_latitude": "40.7946667",
      "poi_longitude": "-111.9318484",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-578-8226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd7-7630-9ec4-6171e2e70567",
        "storage_key": "property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdYe9Mxj0UocRPh_iI00-Utk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_0e4ec886-a051-4ba2-978d-3f3abfa85fbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Judge Memorial Catholic High School",
      "poi_type": "Education",
      "poi_address": "650 S 1100 E, Salt Lake City, UT 84102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-29b1-76de-a386-424331071e04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-29b1-76de-a386-424331071e04",
        "storage_key": "property/6767906449167707/01a0253b-29b1-76de-a386-424331071e04.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.judgememorial.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6112274562564943449&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "judge-memorial-catholic-high-school",
      "poi_latitude": "40.7550787",
      "poi_longitude": "-111.8601656",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 801-517-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd7-7630-9ec4-6171e2e70567",
        "storage_key": "property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc8m4xF71UocRWe5Wl1Qp01Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_42712d9b-cdcd-4e58-b45b-7bbf7f683e96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Discovery Gateway Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "444 W 100 S, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Children's museum featuring interactive exhibits & workshops, plus a terrace with a real helicopter.",
      "poi_long_description": "Children's museum featuring interactive exhibits & workshops, plus a terrace with a real helicopter.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-2d50-757b-952a-d7d239d75e8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-2d50-757b-952a-d7d239d75e8b",
        "storage_key": "property/6767906449167707/01a0253b-2d50-757b-952a-d7d239d75e8b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.discoverygateway.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17951860003333878379&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "discovery-gateway-childrens-museum",
      "poi_latitude": "40.7673645",
      "poi_longitude": "-111.9039348",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 801-456-5437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd8-71ac-b275-218a24a25b6c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd8-71ac-b275-218a24a25b6c",
        "storage_key": "property/6767906449167707/01a01ae6-7dd8-71ac-b275-218a24a25b6c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJY2SVLwD1UocRazJCXI_RIfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_47b02d55-ebe9-410a-a5cb-ff18bc7e7fe9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Clark Planetarium",
      "poi_type": "Entertainment",
      "poi_address": "110 400 W, Salt Lake City, UT 84101, USA",
      "poi_short_description": "State-of-the-art venue featuring 3-D IMAX films, laser light shows & exhibits about space & science.",
      "poi_long_description": "State-of-the-art venue featuring 3-D IMAX films, laser light shows & exhibits about space & science.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-4de7-7490-a181-69e51de70cb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-4de7-7490-a181-69e51de70cb0",
        "storage_key": "property/6767906449167707/01a01ae9-4de7-7490-a181-69e51de70cb0.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "https://slco.org/clark-planetarium/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7437435684685201556&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clark-planetarium",
      "poi_latitude": "40.7666699",
      "poi_longitude": "-111.9033733",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 385-468-7827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd7-7630-9ec4-6171e2e70567",
        "storage_key": "property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu5H6uwH1UocRlMB5mVkUN2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "planetarium"
    },
    {
      "id": "custom_c762b319-f6a4-472c-9222-58a8a95c3186",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "The Depot",
      "poi_type": "Entertainment",
      "poi_address": "13 N 400 W, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Modern concert venue & event center featuring touring bands & DJs in a historic Union Pacific depot.",
      "poi_long_description": "Modern concert venue & event center featuring touring bands & DJs in a historic Union Pacific depot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-4822-7258-adf7-c30c2d40c8a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-4822-7258-adf7-c30c2d40c8a1",
        "storage_key": "property/6767906449167707/01a01ae9-4822-7258-adf7-c30c2d40c8a1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.depotslc.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=2801139701071400673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-depot",
      "poi_latitude": "40.7696612",
      "poi_longitude": "-111.9030338",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 801-456-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-b5a8cad546bb",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLyurbwD1UocR4c6akLel3yY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_dc1c024e-0ec1-4179-8ae0-ce8b85238bf5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Eccles Theater",
      "poi_type": "Entertainment",
      "poi_address": "131 S Main St, Salt Lake City, UT 84111, USA",
      "poi_short_description": "Modern performing arts venue with a 2,400-seat main stage & a 145-seat black-box theater.",
      "poi_long_description": "Modern performing arts venue with a 2,400-seat main stage & a 145-seat black-box theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-4d2c-72f5-ae59-3b9e41cdd10c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-4d2c-72f5-ae59-3b9e41cdd10c",
        "storage_key": "property/6767906449167707/01a01ae9-4d2c-72f5-ae59-3b9e41cdd10c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.saltlakecountyarts.org/venues/eccles-theater/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14229513748307677757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eccles-theater",
      "poi_latitude": "40.76636269999999",
      "poi_longitude": "-111.8905835",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 385-468-1010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-b5a8cad546bb",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMatnFg_1UocRPZJq5lxjecU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_0f2a5f67-39b7-442a-abba-fe81600551a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Abravanel Hall",
      "poi_type": "Entertainment",
      "poi_address": "123 W S Temple St, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Refined concert hall with a dramatic lobby hosting the Utah Symphony & other well-known performers.",
      "poi_long_description": "Refined concert hall with a dramatic lobby hosting the Utah Symphony & other well-known performers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-3377-76dd-b171-c94f005eea8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-3377-76dd-b171-c94f005eea8c",
        "storage_key": "property/6767906449167707/01a0253b-3377-76dd-b171-c94f005eea8c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.saltlakecountyarts.org/venues/abravanel-hall/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12865435029714297013&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abravanel-hall",
      "poi_latitude": "40.7688268",
      "poi_longitude": "-111.8953825",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 385-468-1010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-b5a8cad546bb",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLU0cUgb1UocRteD82v40i7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "concert_hall"
    },
    {
      "id": "custom_9a4130c2-899f-4d13-8158-9403b1e4d34f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Gallivan Center",
      "poi_type": "Entertainment",
      "poi_address": "50 E 200 S, Salt Lake City, UT 84111, USA",
      "poi_short_description": "Urban space with an outdoor concert stage, an ice skating rink and free summer concerts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-4fd8-763c-904c-69801909b0e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-4fd8-763c-904c-69801909b0e5",
        "storage_key": "property/6767906449167707/01a01ae9-4fd8-763c-904c-69801909b0e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thegallivancenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2629290324808164545&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gallivan-center",
      "poi_latitude": "40.7647446",
      "poi_longitude": "-111.8894164",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-535-6110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-b5a8cad546bb",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTwp-uA_1UocRweSPrZ4dfSQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_f8c77df0-921d-4f3c-a69b-fe26530c87a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Rose Wagner Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "138 W Broadway, Salt Lake City, UT 84101, USA",
      "poi_short_description": "3-venue complex hosting dance & theater performances, the Sundance Film Festival & an art gallery.",
      "poi_long_description": "3-venue complex hosting dance & theater performances, the Sundance Film Festival & an art gallery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-3567-70c4-90df-9d0e92e2ca56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-3567-70c4-90df-9d0e92e2ca56",
        "storage_key": "property/6767906449167707/01a0253b-3567-70c4-90df-9d0e92e2ca56.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saltlakecountyarts.org/venues/the-rose/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2020968803285896807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rose-wagner-performing-arts-center",
      "poi_latitude": "40.7632284",
      "poi_longitude": "-111.8953657",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 801-355-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-b5a8cad546bb",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpY898VWKUocRZ44ARmvsCxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_1b7c6066-a63b-46f1-9933-3c31273fb0ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Broadway Centre Cinemas, operated by Salt Lake Film Society",
      "poi_type": "Entertainment",
      "poi_address": "111 E Broadway, 300 S, Salt Lake City, UT 84111, USA",
      "poi_short_description": "6-screen cinema featuring 1st-run foreign & indie films along with unique concessions & pizza.",
      "poi_long_description": "6-screen cinema featuring 1st-run foreign & indie films along with unique concessions & pizza.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-4b9d-7703-be43-823ffb08e0f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-4b9d-7703-be43-823ffb08e0f7",
        "storage_key": "property/6767906449167707/01a01ae9-4b9d-7703-be43-823ffb08e0f7.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://slfs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7678171899066084844&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broadway-centre-cinemas-operated-by-salt-lake-film-society",
      "poi_latitude": "40.7631906",
      "poi_longitude": "-111.8874204",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 801-321-0310",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-7ffa-722e-9861-c03e2b81ad54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae9-7ffa-722e-9861-c03e2b81ad54",
        "storage_key": "property/6767906449167707/01a01ae9-7ffa-722e-9861-c03e2b81ad54.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJrS_p5hH1UocR7G04WKlYjmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_5c7b744c-0c56-4d78-9f6b-1f30d307e1c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Brewvies Cinema Pub",
      "poi_type": "Entertainment",
      "poi_address": "677 S 200 W, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Cozy cinema featuring new releases, indie films & events, plus pub grub, craft beer & a full bar.",
      "poi_long_description": "Cozy cinema featuring new releases, indie films & events, plus pub grub, craft beer & a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-3940-70ea-953e-92e78e4d81ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-3940-70ea-953e-92e78e4d81ce",
        "storage_key": "property/6767906449167707/01a0253b-3940-70ea-953e-92e78e4d81ce.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.brewvies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12693514764580144158&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brewvies-cinema-pub",
      "poi_latitude": "40.7545875",
      "poi_longitude": "-111.8961652",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 801-355-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-7ffa-722e-9861-c03e2b81ad54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae9-7ffa-722e-9861-c03e2b81ad54",
        "storage_key": "property/6767906449167707/01a01ae9-7ffa-722e-9861-c03e2b81ad54.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJEdYGqxn1UocRHsT53WxsKLA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_5aec35be-daf0-4fa7-bcb2-220f13171c5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Utah's Hogle Zoo",
      "poi_type": "Entertainment",
      "poi_address": "2600 Sunnyside Ave S, Salt Lake City, UT 84108, USA",
      "poi_short_description": "Modern, 42-acre zoo boasting hundreds of animals & tropical gardens, plus a train & carousel.",
      "poi_long_description": "Modern, 42-acre zoo boasting hundreds of animals & tropical gardens, plus a train & carousel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-54fa-7460-8f22-ce6e3f52b942.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae6-54fa-7460-8f22-ce6e3f52b942",
        "storage_key": "property/6767906449167707/01a01ae6-54fa-7460-8f22-ce6e3f52b942.webp",
        "width": 1280,
        "height": 887
      },
      "poi_business_url": "https://www.hoglezoo.org/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=8354643522834437222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "utahs-hogle-zoo",
      "poi_latitude": "40.7503666",
      "poi_longitude": "-111.8141741",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 801-584-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-b5a8cad546bb",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJidxheRv1UocRZpSQ6wSo8XM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_5b2d5f2f-4fb5-4963-a290-a5a1f8617c6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Intermountain Health LDS Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "8th Ave, C St E, Salt Lake City, UT 84143, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-6322-7414-8560-72f863f385b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae6-6322-7414-8560-72f863f385b5",
        "storage_key": "property/6767906449167707/01a01ae6-6322-7414-8560-72f863f385b5.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://intermountainhealthcare.org/locations/lds-hospital?utm_source=yext&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=2659205804862327663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "intermountain-health-lds-hospital",
      "poi_latitude": "40.7784879",
      "poi_longitude": "-111.8803369",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 801-408-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-bb0ed71c018b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-bb0ed71c018b",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-bb0ed71c018b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ14_kWJ_1UocRb8t5J5dl5yQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1e1cf699-c640-479b-8f2e-7addd6abc853",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "CommonSpirit Holy Cross Hospital - Salt Lake",
      "poi_type": "Health and Wellness",
      "poi_address": "1050 E S Temple St, Salt Lake City, UT 84102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-3504-77bb-9b12-af3529fc42a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-3504-77bb-9b12-af3529fc42a3",
        "storage_key": "property/6767906449167707/01a0253b-3504-77bb-9b12-af3529fc42a3.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "https://www.mountain.commonspirit.org/location/holy-cross-hospital-salt-lake",
      "poi_directions_map_url": "https://maps.google.com/?cid=17694297192433482697&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "commonspirit-holy-cross-hospital---salt-lake",
      "poi_latitude": "40.7679502",
      "poi_longitude": "-111.8613533",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-350-4111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-bb0ed71c018b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-bb0ed71c018b",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-bb0ed71c018b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJMwXbNmP1UocRyXswUYzFjvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_994f516d-18ef-48b4-b84a-a1f030088111",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Fourth Street Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "409 W 400 S, Salt Lake City, UT 84101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-39d0-7678-9a70-0b90d11b952c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-39d0-7678-9a70-0b90d11b952c",
        "storage_key": "property/6767906449167707/01a0253b-39d0-7678-9a70-0b90d11b952c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://fourthstreetclinic.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3936145691963647223&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fourth-street-clinic",
      "poi_latitude": "40.7602114",
      "poi_longitude": "-111.9031102",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 801-364-0058",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-bb0ed71c018b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-bb0ed71c018b",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-bb0ed71c018b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJS66OygL1UocR92St-ab_nzY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_8ca50d04-07cf-4b2b-b2ac-946810985073",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Intermountain Health North Temple Clinic - Family Medicine",
      "poi_type": "Health and Wellness",
      "poi_address": "54 N 8th W, Salt Lake City, UT 84116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-39bf-75cd-8eb0-3190a072d5c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-39bf-75cd-8eb0-3190a072d5c2",
        "storage_key": "property/6767906449167707/01a0253b-39bf-75cd-8eb0-3190a072d5c2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://intermountainhealthcare.org/locations/north-temple-clinic?utm_source=yext&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=15086757830387920552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "intermountain-health-north-temple-clinic---family-medicine",
      "poi_latitude": "40.7707163",
      "poi_longitude": "-111.913569",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 801-408-8654",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-b5a8cad546bb",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFUBSAlf0UocRqG6dTFDuXtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "custom_75f0a6a0-af32-4cb9-a054-82dc4b7aa9e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "72 S Main St, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-511c-73ae-ad75-e4338c8b0020.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-511c-73ae-ad75-e4338c8b0020",
        "storage_key": "property/6767906449167707/01a01ae9-511c-73ae-ad75-e4338c8b0020.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-72+s+main+st-salt+lake+city-ut-84101/id=19121",
      "poi_directions_map_url": "https://maps.google.com/?cid=559908528803329643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "40.7676059",
      "poi_longitude": "-111.891434",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 801-531-0583",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-8013-76d0-a4d4-04960f84a580.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae9-8013-76d0-a4d4-04960f84a580",
        "storage_key": "property/6767906449167707/01a01ae9-8013-76d0-a4d4-04960f84a580.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxfEqprT1UocRa7YIJtcxxQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_f735cbed-eca4-4951-8a36-54ae1b3bacf8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1110 S 300 W, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-3d3c-7378-981e-5cb5dab46451.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-3d3c-7378-981e-5cb5dab46451",
        "storage_key": "property/6767906449167707/01a0253b-3d3c-7378-981e-5cb5dab46451.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/salt-lake-city-ut-pharmacies/1110-s-300-w-salt-lake-city-ut-84101/storeid=17596?WT.mc_id=LS_GOOGLE_RX_17596",
      "poi_directions_map_url": "https://maps.google.com/?cid=1577267718418187264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.7446888",
      "poi_longitude": "-111.9008568",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 801-401-9563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-8013-76d0-a4d4-04960f84a580.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae9-8013-76d0-a4d4-04960f84a580",
        "storage_key": "property/6767906449167707/01a01ae9-8013-76d0-a4d4-04960f84a580.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR7ScwCb1UocRAMQBGKKU4xU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_487e6725-58c7-47b4-a638-97e8c94f6774",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "175 E 400 S Ste 100, Salt Lake City, UT 84111, USA",
      "poi_short_description": "Members-only gym chain providing equipment, plus tanning beds, and massage beds.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-5f9a-70c0-8c14-ad6cae45b442.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae6-5f9a-70c0-8c14-ad6cae45b442",
        "storage_key": "property/6767906449167707/01a01ae6-5f9a-70c0-8c14-ad6cae45b442.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/salt-lake-city-ut?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=18208306272100797670&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "40.7610034",
      "poi_longitude": "-111.8859766",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 801-521-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-b5a8cad546bb",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Up5yBH1UocR5swVLhXmsPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3cc990ca-76c5-4e1b-8adf-c112e4027069",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "BODYBAR Pilates - Salt Lake City",
      "poi_type": "Health and Wellness",
      "poi_address": "330 E 400 S Ste 105, Salt Lake City, UT 84111, USA",
      "poi_short_description": "Relaxed studio for Pilates workouts blending classical moves with fast-paced cardio exercises, plus a boutique.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-448f-765c-9093-291e9d84128f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-448f-765c-9093-291e9d84128f",
        "storage_key": "property/6767906449167707/01a0253b-448f-765c-9093-291e9d84128f.webp",
        "width": 1280,
        "height": 707
      },
      "poi_business_url": "https://bodybarpilates.com/studios/utah/downtown-salt-lake-city/?utm_source=gbp_location_id=48736",
      "poi_directions_map_url": "https://maps.google.com/?cid=11940100022353485513&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bodybar-pilates---salt-lake-city",
      "poi_latitude": "40.7600007",
      "poi_longitude": "-111.8822121",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-528-6860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd7-7630-9ec4-6171e2e70567",
        "storage_key": "property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIYCW2sv1UocRyV4Df7XBs6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8399b937-37a1-4c8c-a94c-7ceb7268ba40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "CorePower Yoga - Trolley Square",
      "poi_type": "Health and Wellness",
      "poi_address": "602 E 500 S p101, Salt Lake City, UT 84102, USA",
      "poi_short_description": "Yoga studio specializing in hot/heated classes and fusion-style vinyasa flow, with a clean, modern space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-5f26-756d-8b45-27ec62f0045e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae6-5f26-756d-8b45-27ec62f0045e",
        "storage_key": "property/6767906449167707/01a01ae6-5f26-756d-8b45-27ec62f0045e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.corepoweryoga.com/yoga-studios/ut/salt-lake-city/trolley-square",
      "poi_directions_map_url": "https://maps.google.com/?cid=6724069479872996149&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corepower-yoga---trolley-square",
      "poi_latitude": "40.7576798",
      "poi_longitude": "-111.8735553",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-363-9642",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd7-7630-9ec4-6171e2e70567",
        "storage_key": "property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjaL72mn1UocRNSPg-JCxUF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_177de360-2574-42d1-a7f8-5563e48b343b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Central City Recreation Center",
      "poi_type": "Health and Wellness",
      "poi_address": "615 S 300 E, Salt Lake City, UT 84111, USA",
      "poi_short_description": "Casual gym and rec center offering basketball, weights and various classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-5653-76af-9df9-1ba60369e5a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-5653-76af-9df9-1ba60369e5a1",
        "storage_key": "property/6767906449167707/01a01ae9-5653-76af-9df9-1ba60369e5a1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://saltlakecounty.gov/central-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5634019860342790730&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-city-recreation-center",
      "poi_latitude": "40.7558757",
      "poi_longitude": "-111.8819615",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 385-468-1550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-b5a8cad546bb",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl6X-RBX1UocRSlo6cTYPME4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_56b299f3-a464-4611-9259-028a9575a50b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "City Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 N State St, Salt Lake City, UT 84103, USA",
      "poi_short_description": "Scenic, tree-lined park along City Creek featuring an arched bridge & walking paths.",
      "poi_long_description": "Scenic, tree-lined park along City Creek featuring an arched bridge & walking paths.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-5dea-70c7-85cd-fb059be20e4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-5dea-70c7-85cd-fb059be20e4e",
        "storage_key": "property/6767906449167707/01a01ae9-5dea-70c7-85cd-fb059be20e4e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.slc.gov/parks/parks-division/city-creek-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12389509335901379207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-creek-park",
      "poi_latitude": "40.7718638",
      "poi_longitude": "-111.8877533",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-972-7860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd8-71ac-b275-24885f2134ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd8-71ac-b275-24885f2134ad",
        "storage_key": "property/6767906449167707/01a01ae6-7dd8-71ac-b275-24885f2134ad.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSwHy7gn1UocRh5rJOxlh8Ks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2f0866fb-f059-415a-955d-7f99bc829903",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Brigham Young Historic Park",
      "poi_type": "Entertainment",
      "poi_address": "100 N State St, Salt Lake City, UT 84150, USA",
      "poi_short_description": "Formerly the property of Brigham Young, this peaceful grassy park hosts concerts in the summer.",
      "poi_long_description": "Formerly the property of Brigham Young, this peaceful grassy park hosts concerts in the summer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-40cb-771e-ac5f-332ca76e7497.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-40cb-771e-ac5f-332ca76e7497",
        "storage_key": "property/6767906449167707/01a0253b-40cb-771e-ac5f-332ca76e7497.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.templesquare.org/eng/pois/landmarks/brigham-young-historic-park?y_source=1_MzA1ODU2NTktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10290825926277477096&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brigham-young-historic-park",
      "poi_latitude": "40.7712824",
      "poi_longitude": "-111.8877556",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 801-240-8945",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd9-76af-bb94-b94f345ec76d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd9-76af-bb94-b94f345ec76d",
        "storage_key": "property/6767906449167707/01a01ae6-7dd9-76af-bb94-b94f345ec76d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjZLukAn1UocR6DImJahb0I4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_bce9f56c-ed26-45f2-b0e8-9159aa980e86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Temple Square",
      "poi_type": "Entertainment",
      "poi_address": "50 North Temple, Salt Lake City, UT 84150, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-550d-71a8-9f5e-f68fdcbe26d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae6-550d-71a8-9f5e-f68fdcbe26d6",
        "storage_key": "property/6767906449167707/01a01ae6-550d-71a8-9f5e-f68fdcbe26d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.templesquare.org/eng?y_source=1_MzA1ODU2NjYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10112787064908179005&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "temple-square",
      "poi_latitude": "40.7706273",
      "poi_longitude": "-111.8910873",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 801-240-8945",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd9-76af-bb94-b94f345ec76d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd9-76af-bb94-b94f345ec76d",
        "storage_key": "property/6767906449167707/01a01ae6-7dd9-76af-bb94-b94f345ec76d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Q6J5Aj1UocRPWYEdUHWV4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_ccac961e-da6b-401d-bda3-e2b001ef1c8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Salt Lake City Public Library",
      "poi_type": "Education",
      "poi_address": "210 E 400 S, Salt Lake City, UT 84111, USA",
      "poi_short_description": "Modern library known for its natural light & curved 6-story walkable wall built with high-UV glass.",
      "poi_long_description": "Modern library known for its natural light & curved 6-story walkable wall built with high-UV glass.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-4acb-7328-85fc-79834812a3a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae6-4acb-7328-85fc-79834812a3a9",
        "storage_key": "property/6767906449167707/01a01ae6-4acb-7328-85fc-79834812a3a9.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://services.slcpl.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=66428271525700298&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salt-lake-city-public-library",
      "poi_latitude": "40.7600376",
      "poi_longitude": "-111.8846127",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 801-524-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7e06-71e2-b7b6-91ce564d1450.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7e06-71e2-b7b6-91ce564d1450",
        "storage_key": "property/6767906449167707/01a01ae6-7e06-71e2-b7b6-91ce564d1450.webp",
        "width": 192,
        "height": 174
      },
      "poi_google_place_id": "ChIJr0salBP1UocRyiJVNykA7AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_2429dbc4-0435-49d4-abbc-c78c8f54d114",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Pioneer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "350 S 300 W, Salt Lake City, UT 84101, USA",
      "poi_short_description": "This park with paths, a playground & sports courts is host to a weekly farmers market during summer.",
      "poi_long_description": "This park with paths, a playground & sports courts is host to a weekly farmers market during summer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-5baf-7201-a4df-b41e8a2793fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-5baf-7201-a4df-b41e8a2793fc",
        "storage_key": "property/6767906449167707/01a01ae9-5baf-7201-a4df-b41e8a2793fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.slc.gov/parks/parks-division/pioneer-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12152940112993781891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pioneer-park",
      "poi_latitude": "40.76161",
      "poi_longitude": "-111.9012005",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 801-535-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd8-71ac-b275-24885f2134ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd8-71ac-b275-24885f2134ad",
        "storage_key": "property/6767906449167707/01a01ae6-7dd8-71ac-b275-24885f2134ad.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJOQu9IwP1UocRgwiXy6Tqp6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_9bdb8396-1371-4ebf-b427-4c144d29637b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Memory Grove",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 N Canyon Rd, Salt Lake City, UT 84103, USA",
      "poi_short_description": "Serene space with monuments, fountains, creekside paths, an off-leash area & picnic tables.",
      "poi_long_description": "Serene space with monuments, fountains, creekside paths, an off-leash area & picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-5c54-73d6-a257-7a793f8e088c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-5c54-73d6-a257-7a793f8e088c",
        "storage_key": "property/6767906449167707/01a01ae9-5c54-73d6-a257-7a793f8e088c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.slc.gov/parks/parks-division/memory-grove/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4140555976655699573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memory-grove",
      "poi_latitude": "40.7773271",
      "poi_longitude": "-111.8844583",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 801-972-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd8-71ac-b275-24885f2134ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd8-71ac-b275-24885f2134ad",
        "storage_key": "property/6767906449167707/01a01ae6-7dd8-71ac-b275-24885f2134ad.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJeWT6b6H1UocRdf4uIbk1djk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b809a5b5-00c9-4751-8644-bcc24d46d31b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Ensign Peak Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1002 Ensign Vista Dr, Salt Lake City, UT 84103, USA",
      "poi_short_description": "Good for kids, this park features hiking and other activities in a valley.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-5c03-722e-87e2-65db6d69d37e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-5c03-722e-87e2-65db6d69d37e",
        "storage_key": "property/6767906449167707/01a01ae9-5c03-722e-87e2-65db6d69d37e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.slc.gov/parks/parks-division/ensign-peak-nature-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16503381863724072296&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ensign-peak-nature-park",
      "poi_latitude": "40.7928457",
      "poi_longitude": "-111.888341",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-972-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd8-71ac-b275-24885f2134ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd8-71ac-b275-24885f2134ad",
        "storage_key": "property/6767906449167707/01a01ae6-7dd8-71ac-b275-24885f2134ad.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdUAB5sb1UocRaL3ly13KB-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_5fe12fce-5162-4f32-9c35-093cb7d246ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Jordan River Parkway - Gadsby Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1223 W North Temple St, Salt Lake City, UT 84116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-629c-74a8-89eb-e18e093ef4ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-629c-74a8-89eb-e18e093ef4ec",
        "storage_key": "property/6767906449167707/01a01ae9-629c-74a8-89eb-e18e093ef4ec.webp",
        "width": 1280,
        "height": 801
      },
      "poi_business_url": "https://publicart.slc.gov/art/jordan-river-current-gadsby-trailhead/",
      "poi_directions_map_url": "https://maps.google.com/?cid=809468926956850949&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jordan-river-parkway---gadsby-trailhead",
      "poi_latitude": "40.7711299",
      "poi_longitude": "-111.9270984",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 801-972-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-8014-714a-8fda-595ec16a4c72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae9-8014-714a-8fda-595ec16a4c72",
        "storage_key": "property/6767906449167707/01a01ae9-8014-714a-8fda-595ec16a4c72.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJtfXF2fP1UocRBc_6R7PPOws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_085c44a8-f7c0-46ea-b57c-5e9c95581af5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "North Temple Bridge/Guadalupe",
      "poi_type": "Transportation & Transit",
      "poi_address": "Salt Lake City, UT 84101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-63c5-72ee-a0a3-a560e43a0278.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-63c5-72ee-a0a3-a560e43a0278",
        "storage_key": "property/6767906449167707/01a01ae9-63c5-72ee-a0a3-a560e43a0278.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11062362659526238885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-temple-bridgeguadalupe",
      "poi_latitude": "40.771608",
      "poi_longitude": "-111.9048057",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-8096-7599-b3ea-6093045383d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-8096-7599-b3ea-6093045383d4",
        "storage_key": "property/6767906449167707/01a01ae6-8096-7599-b3ea-6093045383d4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJN38TL1X0UocRpWKbWTpohZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_6e435e16-99f5-4418-8352-015b237d443e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "North Temple Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Salt Lake City, UT 84103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-6ccc-70a9-8254-1a521619677c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae6-6ccc-70a9-8254-1a521619677c",
        "storage_key": "property/6767906449167707/01a01ae6-6ccc-70a9-8254-1a521619677c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17090140258902178030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-temple-station",
      "poi_latitude": "40.7727569",
      "poi_longitude": "-111.905134",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-8088-772e-be22-379e184f265b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-8088-772e-be22-379e184f265b",
        "storage_key": "property/6767906449167707/01a01ae6-8088-772e-be22-379e184f265b.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJTQo10FT0UocR7nh3nQRgLO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_781d2e97-aa48-4d64-b84a-c2aee5130e19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Intermodal Hub - Salt Lake City",
      "poi_type": "Transportation & Transit",
      "poi_address": "300 S 600 W, Salt Lake City, UT 84101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-6440-7102-87aa-4afa5fce0741.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-6440-7102-87aa-4afa5fce0741",
        "storage_key": "property/6767906449167707/01a01ae9-6440-7102-87aa-4afa5fce0741.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rideuta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17285654361944147072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "intermodal-hub---salt-lake-city",
      "poi_latitude": "40.7635085",
      "poi_longitude": "-111.9087442",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 801-355-9579",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-800c-74fa-93ec-407a548f454f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae9-800c-74fa-93ec-407a548f454f",
        "storage_key": "property/6767906449167707/01a01ae9-800c-74fa-93ec-407a548f454f.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJfR3lO_z0UocRgMTcEQ_74u8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_b9bd878f-47f2-48c0-954a-bd9f15d1f71b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Arena Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "350 S. Temple, Salt Lake City, UT 84101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-42bd-73ab-9004-13cc69920366.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-42bd-73ab-9004-13cc69920366",
        "storage_key": "property/6767906449167707/01a0253b-42bd-73ab-9004-13cc69920366.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8578001310283178300&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arena-station",
      "poi_latitude": "40.7693441",
      "poi_longitude": "-111.9008833",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-8096-7599-b3ea-6093045383d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-8096-7599-b3ea-6093045383d4",
        "storage_key": "property/6767906449167707/01a01ae6-8096-7599-b3ea-6093045383d4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJd-9kjAD1UocRPKFDVr4uC3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_cf1b8977-4ff6-4abf-b4f8-5b14396bab8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Planetarium Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "150 W 400 S, Salt Lake City, UT 84101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-69e5-72f7-8482-a7b091210946.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-69e5-72f7-8482-a7b091210946",
        "storage_key": "property/6767906449167707/01a01ae9-69e5-72f7-8482-a7b091210946.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15275766532044636083&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planetarium-station",
      "poi_latitude": "40.76689560000001",
      "poi_longitude": "-111.9025374",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-8096-7599-b3ea-6093045383d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-8096-7599-b3ea-6093045383d4",
        "storage_key": "property/6767906449167707/01a01ae6-8096-7599-b3ea-6093045383d4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6-WhuwH1UocRsz9S9rls_tM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_2d63a88c-a5b4-4962-b7e8-79de6fc4a511",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "City Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "55 S Main St, Salt Lake City, UT 84101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-6a8c-7071-843a-d79b433ee17b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-6a8c-7071-843a-d79b433ee17b",
        "storage_key": "property/6767906449167707/01a01ae9-6a8c-7071-843a-d79b433ee17b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rideuta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1001939613389762446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-center",
      "poi_latitude": "40.7676222",
      "poi_longitude": "-111.8911029",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-8096-7599-b3ea-6093045383d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-8096-7599-b3ea-6093045383d4",
        "storage_key": "property/6767906449167707/01a01ae6-8096-7599-b3ea-6093045383d4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJxWlmNQ_1UocRji99FsWa5w0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_6a8a722b-1244-4512-8e30-d6c4f346cb56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Old GreekTown 554 W.200 S.",
      "poi_type": "Transportation & Transit",
      "poi_address": "Salt Lake City, UT 84101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-443e-766c-ab14-4ab9279e19f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-443e-766c-ab14-4ab9279e19f3",
        "storage_key": "property/6767906449167707/01a0253b-443e-766c-ab14-4ab9279e19f3.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11544853327210008373&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-greektown-554-w200-s",
      "poi_latitude": "40.7650182",
      "poi_longitude": "-111.9066102",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-8096-7599-b3ea-6093045383d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-8096-7599-b3ea-6093045383d4",
        "storage_key": "property/6767906449167707/01a01ae6-8096-7599-b3ea-6093045383d4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpbIBcP70UocRNc9WEO-ON6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_cc615328-aa2e-417a-86d1-4e5289700d78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Library Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Salt Lake City, UT 84111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-4632-7533-8b6b-60419098c5ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-4632-7533-8b6b-60419098c5ff",
        "storage_key": "property/6767906449167707/01a0253b-4632-7533-8b6b-60419098c5ff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1090300848525856459&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "library-station",
      "poi_latitude": "40.760637",
      "poi_longitude": "-111.883942",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-8096-7599-b3ea-6093045383d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-8096-7599-b3ea-6093045383d4",
        "storage_key": "property/6767906449167707/01a01ae6-8096-7599-b3ea-6093045383d4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJL3GkoRP1UocRy86wVtiGIQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_aaad8588-5a0c-4489-96a1-c2224a51e843",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Salt Lake City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3920 W Terminal Dr, Salt Lake City, UT 84122, USA",
      "poi_short_description": "Airport featuring a number of restaurants plus free WiFi & lots of art displays.",
      "poi_long_description": "Airport featuring a number of restaurants plus free WiFi & lots of art displays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-6c0e-769a-afd0-e9349b77f2ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae6-6c0e-769a-afd0-e9349b77f2ec",
        "storage_key": "property/6767906449167707/01a01ae6-6c0e-769a-afd0-e9349b77f2ec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://slcairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8007192497092118553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salt-lake-city-international-airport",
      "poi_latitude": "40.7903145",
      "poi_longitude": "-111.9771441",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 801-575-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-807e-730d-9564-a94989dfa443.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-807e-730d-9564-a94989dfa443",
        "storage_key": "property/6767906449167707/01a01ae6-807e-730d-9564-a94989dfa443.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6fTXZ4vzUocRGUhZ9SZDH28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_95ae4de5-e70c-4ac8-96b5-6d9bc9d5e569",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Church Office Building - The Church of Jesus Christ of Latter-day Saints",
      "poi_type": "Entertainment",
      "poi_address": "50 E North Temple St, Salt Lake City, UT 84150, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-742f-776a-a6fb-a1a8b9c39d50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-742f-776a-a6fb-a1a8b9c39d50",
        "storage_key": "property/6767906449167707/01a01ae9-742f-776a-a6fb-a1a8b9c39d50.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.templesquare.org/eng/buildings/church-office-building?y_source=1_MzA1ODU2NTctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16607643768646191966&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "church-office-building---the-church-of-jesus-christ-of-latter-day-saints",
      "poi_latitude": "40.7711903",
      "poi_longitude": "-111.889389",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 801-240-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-8053-746b-adba-cad99f6c0adb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae9-8053-746b-adba-cad99f6c0adb",
        "storage_key": "property/6767906449167707/01a01ae9-8053-746b-adba-cad99f6c0adb.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJOYAsxwf1UocRXstiOgQ0euY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_6bd0ad2f-06f5-4423-a0fb-d96564004ca2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Zions Bank",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 S Main St, Salt Lake City, UT 84133, USA",
      "poi_short_description": "Part of a local chain of financial institutions, this branch provides ATMs, mortgages, and wealth management services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-481e-772c-9ec7-aae6f275ef0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-481e-772c-9ec7-aae6f275ef0d",
        "storage_key": "property/6767906449167707/01a0253b-481e-772c-9ec7-aae6f275ef0d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.zionsbank.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3033518488303510699&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zions-bank",
      "poi_latitude": "40.769053",
      "poi_longitude": "-111.8904223",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 801-844-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-56e6-775d-8315-520c05e4cf43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0253b-56e6-775d-8315-520c05e4cf43",
        "storage_key": "property/6767906449167707/01a0253b-56e6-775d-8315-520c05e4cf43.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJKxGE6Aj1UocRqyTpKv44GSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bank"
    },
    {
      "id": "custom_3e5578a3-b186-4bea-9ea6-e5cf9cae4f9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "The University of Utah",
      "poi_type": "Education",
      "poi_address": "201 Presidents' Cir, Salt Lake City, UT 84112, USA",
      "poi_short_description": "This research university near the Wasatch Mountains features 100 acres of gardens plus an arboretum.",
      "poi_long_description": "This research university near the Wasatch Mountains features 100 acres of gardens plus an arboretum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-4544-71e6-8996-651e6c731829.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae6-4544-71e6-8996-651e6c731829",
        "storage_key": "property/6767906449167707/01a01ae6-4544-71e6-8996-651e6c731829.webp",
        "width": 715,
        "height": 515
      },
      "poi_business_url": "https://www.utah.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15966664552946993518&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-utah",
      "poi_latitude": "40.7649368",
      "poi_longitude": "-111.8421021",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 801-581-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7dd7-7630-9ec4-6171e2e70567",
        "storage_key": "property/6767906449167707/01a01ae6-7dd7-7630-9ec4-6171e2e70567.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG_NN6OpfUocRbgk63tD8lN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e9747b34-89c0-4885-8e33-3c7e3c915bed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Utah State Capitol",
      "poi_type": "Major Employers & Offices",
      "poi_address": "350 N State St, Salt Lake City, UT 84114, USA",
      "poi_short_description": "Built in 1916, the renovated neoclassical revival building offers original murals, exhibits & tours.",
      "poi_long_description": "Built in 1916, the renovated neoclassical revival building offers original murals, exhibits & tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-66fb-702f-90d3-4932bbd0246d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-66fb-702f-90d3-4932bbd0246d",
        "storage_key": "property/6767906449167707/01a01ae9-66fb-702f-90d3-4932bbd0246d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://utahstatecapitol.utah.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17036286960393059658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "utah-state-capitol",
      "poi_latitude": "40.7778658",
      "poi_longitude": "-111.8880558",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-538-3074",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-80a7-717e-a0fd-7ada793f5614.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-80a7-717e-a0fd-7ada793f5614",
        "storage_key": "property/6767906449167707/01a01ae6-80a7-717e-a0fd-7ada793f5614.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBa4ovRH1UocRSv3YdboMbew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_faa71e4d-ab11-436a-b463-ba03abd8b2f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Salt Lake City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "451 S State St, Salt Lake City, UT 84111, USA",
      "poi_short_description": "Victorian-era city hall noted for its iconic 256-foot clock tower & carved gray sandstone facade.",
      "poi_long_description": "Victorian-era city hall noted for its iconic 256-foot clock tower & carved gray sandstone facade.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-78a2-7231-be99-64e0d186d24b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae6-78a2-7231-be99-64e0d186d24b",
        "storage_key": "property/6767906449167707/01a01ae6-78a2-7231-be99-64e0d186d24b.webp",
        "width": 1280,
        "height": 875
      },
      "poi_business_url": "http://www.slc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=726748788876054070&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salt-lake-city-hall",
      "poi_latitude": "40.75952720000001",
      "poi_longitude": "-111.8870898",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 801-535-7704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-80a7-717e-a0fd-7ada793f5614.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-80a7-717e-a0fd-7ada793f5614",
        "storage_key": "property/6767906449167707/01a01ae6-80a7-717e-a0fd-7ada793f5614.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfWXpWBH1UocRNg7nSSzuFQo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_7bc5eaed-b49c-4b09-86ca-d3eac8f5f52f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Intermountain Healthcare",
      "poi_type": "Major Employers & Offices",
      "poi_address": "36 S State St Fl 22, Salt Lake City, UT 84103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://intermountainhealthcare.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6026760541584295800&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "intermountain-healthcare",
      "poi_latitude": "40.7683478",
      "poi_longitude": "-111.8885745",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 801-442-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-b5a8cad546bb",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy1dGNAn1UocReAd5C8hao1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e31c08c9-926a-45e9-ac20-2c5b71c21670",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Salt Lake County Government Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2001 S State St, Salt Lake City, UT 84190, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae9-7061-7230-99e1-962f845a5b3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae9-7061-7230-99e1-962f845a5b3e",
        "storage_key": "property/6767906449167707/01a01ae9-7061-7230-99e1-962f845a5b3e.webp",
        "width": 1255,
        "height": 736
      },
      "poi_business_url": "https://www.saltlakecounty.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16055782265369013105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salt-lake-county-government-center",
      "poi_latitude": "40.7268795",
      "poi_longitude": "-111.887677",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 385-468-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-80a7-717e-a0fd-7ada793f5614.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-80a7-717e-a0fd-7ada793f5614",
        "storage_key": "property/6767906449167707/01a01ae6-80a7-717e-a0fd-7ada793f5614.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGT5x186KUocRcStWNueY0d4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_0e6f3300-a4bf-4b49-aedb-e29dcf5cfc83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "University of Utah Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "50 Medical Dr N, Salt Lake City, UT 84132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-6368-754d-aaff-04a1c45c272b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01ae6-6368-754d-aaff-04a1c45c272b",
        "storage_key": "property/6767906449167707/01a01ae6-6368-754d-aaff-04a1c45c272b.webp",
        "width": 1179,
        "height": 769
      },
      "poi_business_url": "https://healthcare.utah.edu/hospital/?utm_source=google&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=5918513551681049251&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-utah-hospital",
      "poi_latitude": "40.7714806",
      "poi_longitude": "-111.8366141",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 801-581-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-bb0ed71c018b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-bb0ed71c018b",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-bb0ed71c018b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJXQMMEJdfUocRo9JItrfIIlI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_fb513586-74df-4d61-b751-344f943c1db5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Huntsman Cancer Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1950 E Cir of Hope Dr, Salt Lake City, UT 84112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-4eee-71d2-9513-f301e19b7f15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-4eee-71d2-9513-f301e19b7f15",
        "storage_key": "property/6767906449167707/01a0253b-4eee-71d2-9513-f301e19b7f15.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://healthcare.utah.edu/huntsmancancerinstitute/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6472744945346673892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "huntsman-cancer-hospital",
      "poi_latitude": "40.7733636",
      "poi_longitude": "-111.8348931",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 801-587-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-b5a8cad546bb",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEdt2jpdfUocR5PwX1TvP01k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "custom_611e8446-3e43-43db-bbb0-fa7b39313ade",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "custom",
      "poi_name": "Utah Transit Authority Frontline HeadQuarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "669 W 200 S, Salt Lake City, UT 84101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a0253b-4b9d-748b-89d5-7fb6a988b13c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0253b-4b9d-748b-89d5-7fb6a988b13c",
        "storage_key": "property/6767906449167707/01a0253b-4b9d-748b-89d5-7fb6a988b13c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.rideuta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12383717848871195274&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "utah-transit-authority-frontline-headquarters",
      "poi_latitude": "40.7644325",
      "poi_longitude": "-111.9107868",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-262-5626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01ae6-7df4-7539-bd93-b5a8cad546bb",
        "storage_key": "property/6767906449167707/01a01ae6-7df4-7539-bd93-b5a8cad546bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJESbRafz0UocRitKhlMXN26s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_26ac96e9fe350c4bca067af4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_dcf1db2e3cbae89394cdfcbb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_94d1c3954bb51ef047a0885e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_61e11c7860526982a45ff640",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_7dcd2be613ac744fa09ca037",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b38bfc4aa2f8765d192c5f7c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_85d5bc28addb1108ff774eaf",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "rating": "5",
      "name": "T S",
      "text": "Skyhouse is beautiful, all brand new, quiet and safe and stylish as a 5 star hotel! The customer says staff are all super nice and responsive to every question immediately. Wonderful! The space is actually larger then expected because the layout is straightforward in squares, without losing space to winding turns and hallways.",
      "date": "2026-06-19",
      "title": "false"
    },
    {
      "id": "ec_1df4fb485c76a9e21b39c7a4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "rating": "5",
      "name": "Alec Perschon",
      "text": "I’ve had a great experience living at Skyhouse Apartments in Salt Lake City! Moana has been especially amazing — she’s friendly, professional, and always quick to help whenever something comes up. It really makes a difference having someone like her around who genuinely cares about residents. Overall, it’s been a great place to call home!",
      "date": "2025-10-24",
      "title": "false"
    },
    {
      "id": "ec_a11c8bf4db3e717b82a446fb",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "rating": "5",
      "name": "Avrianna Destefano",
      "text": "I can’t say enough good things about this apartment complex. From the moment I moved in, the staff has been amazing and so supportive. Moana, especially, has been incredible to work with and truly goes above and beyond. I genuinely love living here and highly recommend it to anyone looking for a great place to call home!",
      "date": "2026-01-22",
      "title": "false"
    },
    {
      "id": "ec_3567e8a5364d3a7ddf2f870c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "rating": "5",
      "name": "Thomas Thompson",
      "text": "My wife and I have lived at Skyhouse for the past 4 - 5 years . We have seen three different management staff and the current management is by far the best we have ever had! Monica is a great communicator and she makes me feel very comfortable when I need to approach her with any issues we may have. We really appreciate and enjoy the resident activities that the management staff have implemented. For a pet friendly place the cleaning staff do an amazing job at keeping the place and common areas nice and tighty. Long story short, Sky House is a great place to live! The management staff and cleaning staff deserve a raise.",
      "date": "2024-03-05",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_fc5a02b2baefe5c1f5885dd3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Hempstead - #420",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/4i5v5a?source=180"
    },
    {
      "id": "ec_df477073c8215718f248fbfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae8-dade-70aa-b9df-944b3aea21ec.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01ae8-dade-70aa-b9df-944b3aea21ec",
        "storage_key": "property/6767906449167707/01a01ae8-dade-70aa-b9df-944b3aea21ec.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - Arden",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=pRPUVJRbW8n"
    },
    {
      "id": "ec_5072286c7f13015c3e3c4e1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae8-da6a-740c-8dde-7c33bab5dd71.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01ae8-da6a-740c-8dde-7c33bab5dd71",
        "storage_key": "property/6767906449167707/01a01ae8-da6a-740c-8dde-7c33bab5dd71.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - Nottoway",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kobUWkbxkM2"
    },
    {
      "id": "ec_fa59c515f3c8eef9c13c90df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae8-d9a5-772f-89ce-754f03164b8c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01ae8-d9a5-772f-89ce-754f03164b8c",
        "storage_key": "property/6767906449167707/01a01ae8-d9a5-772f-89ce-754f03164b8c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - Whitehall",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=9JNJkeHvrbp"
    },
    {
      "id": "ec_656c76f1feeca60eb8393316",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167707/01a01ae8-da57-774f-930a-3078fb58fc92.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01ae8-da57-774f-930a-3078fb58fc92",
        "storage_key": "property/6767906449167707/01a01ae8-da57-774f-930a-3078fb58fc92.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - Searles + Den",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=gTTGkVXnL1v"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a03a07-abd0-712a-9bd0-0e77ed8641d2",
      "lead_source": "LANDING_PAGE",
      "name": "Skyhouse Apartments Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-slc",
      "search_query": "apartments with in-unit laundry in Salt Lake City",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in SLC",
      "h2_subtitle": "Find your perfect apartment with in-unit laundry at Skyhouse. Enjoy modern amenities and convenient location in Salt Lake City.",
      "page_copy": "Experience unrivaled convenience at Skyhouse Apartments, where every home is equipped with in-unit laundry. Our community in Salt Lake City caters to those seeking both comfort and style. Enjoy stunning rooftop views of Capitol Hill and Wasatch mountains right from your home. \n\nSkyhouse is strategically located to provide easy access to the vibrant downtown energy and the tranquility of the surrounding area. Our polished studio, one-, and two-bedroom homes offer contemporary finishes, along with amenities like a sun-kissed deck and maid service. Come explore these exceptional spaces where city life meets convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Salt Lake City",
      "seo_description": "Discover Skyhouse Apartments with in-unit laundry in Salt Lake City. Enjoy modern living and convenient city access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "ac-apartments-capitol-hill-slc",
      "search_query": "air conditioned apartments Capitol Hill Salt Lake City UT",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments on Capitol Hill",
      "h2_subtitle": "Discover air conditioned apartments at Skyhouse, located on Capitol Hill. Experience comfort and style in Salt Lake City, UT.",
      "page_copy": "Stay comfortable throughout the seasons at Skyhouse Apartments, offering air conditioned homes on Capitol Hill, Salt Lake City. Our stylish studios, one-, and two-bedroom apartments feature modern finishes alongside premium amenities such as package service and maid service.\n\nEnjoy breathtaking views of the Salt Lake City skyline and the Wasatch mountains, all from the comfort of an air conditioned home. With easy access to TRAX, Skyhouse places you in the heart of the city while keeping the refreshing cool of home close by. Explore downtown energy paired with ultimate comfort today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments, Capitol Hill SLC",
      "seo_description": "Find air conditioned apartments at Skyhouse on Capitol Hill, Salt Lake City. Enjoy modern amenities and stunning views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "stainless-steel-apartments-salt-lake-county",
      "search_query": "apartments with stainless steel appliances Salt Lake County",
      "category": "Amenity",
      "h1_title": "Apartments with Stainless Steel Appliances",
      "h2_subtitle": "Explore apartments in Salt Lake County featuring stainless steel appliances at Skyhouse. Experience stylish living with modern conveniences.",
      "page_copy": "Skyhouse Apartments in Salt Lake County set the standard for elegant living with homes equipped with stainless steel appliances. Our modern studio, one-, and two-bedroom units offer a refined touch, enhancing your culinary experience. Nestled at the edge of Capitol Hill, these homes provide an extraordinary blend of style and function.\n\nWith amenities like a rooftop deck, stunning views of the Wasatch mountains, and easy access to city transit, Skyhouse makes urban living a breeze. Discover the perfect home where sleek design meets convenience in Salt Lake County, all while staying just steps away from downtown energy and scenic beauty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stainless Steel Apartments in Salt Lake County",
      "seo_description": "Discover Skyhouse Apartments with stainless steel appliances in Salt Lake County. Modern living with captivating views and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-slc-84101",
      "search_query": "apartments with fitness center Salt Lake City 84101",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in 84101",
      "h2_subtitle": "Discover Skyhouse Apartments in Salt Lake City, 84101, featuring a state-of-the-art fitness center. Live healthy and enjoy urban convenience.",
      "page_copy": "Stay active and healthy at Skyhouse Apartments, located in the heart of Salt Lake City, 84101. Our community boasts a state-of-the-art fitness center, perfect for maintaining your fitness goals. Complemented by polished studio, one-, and two-bedroom homes, Skyhouse offers the ultimate living experience.\n\nNestled close to Capitol Hill, residents enjoy breathtaking Wasatch views and easy TRAX access for city exploration. With amenities like a rooftop deck and convenient package service, living at Skyhouse means enjoying both style and practicality. It's time to elevate your lifestyle with wellness and luxury in Salt Lake City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Salt Lake City 84101",
      "seo_description": "Skyhouse Apartments in Salt Lake City, 84101 offer a fitness center. Live active and explore convenient amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "rooftop-terrace-apartments-downtown-slc",
      "search_query": "downtown Salt Lake City rooftop terrace apartments",
      "category": "Amenity",
      "h1_title": "Downtown SLC Apartments with Rooftop Terrace",
      "h2_subtitle": "Experience urban living at Skyhouse Apartments in downtown Salt Lake City, featuring a stunning rooftop terrace with breathtaking views.",
      "page_copy": "Skyhouse Apartments offers an exceptional urban lifestyle with a rooftop terrace in downtown Salt Lake City. Enjoy stunning skyline and Wasatch views from this vibrant community on the edge of Capitol Hill. Our stylish studio, one-, and two-bedroom homes come with modern finishes and easy TRAX access.\n\nThe rooftop terrace is perfect for unwinding while admiring the Salt Lake City skyline. With additional amenities like package service, maid service, and south-facing views, Skyhouse Apartments provides a seamless blend of convenience and luxury. Embrace city living with a spectacular setting at Skyhouse today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Downtown SLC Rooftop Terrace Apartments",
      "seo_description": "Discover Skyhouse Apartments with a rooftop terrace in downtown Salt Lake City. Enjoy stunning views and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "studio-apartments-capitol-hill-ut",
      "search_query": "studio apartments capitol hill ut",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Capitol Hill, UT",
      "h2_subtitle": "Explore modern studio apartments at Skyhouse on Capitol Hill, UT. Stylish living with breathtaking views and urban convenience.",
      "page_copy": "Nestled in the vibrant Capitol Hill neighborhood in UT, Skyhouse Apartments offers exquisite studio apartments with panoramic views. These thoughtfully designed spaces feature modern finishes, providing a sleek and stylish living environment that's perfect for city lovers.\n\nBeyond the comfort of your home, enjoy easy access to downtown Salt Lake City through TRAX and the breathtaking scenery of the Wasatch mountains. Skyhouse amenities, including a rooftop deck and convenient package service, ensure every resident enjoys both luxury and convenience. Experience the best of Capitol Hill living with Skyhouse today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments Capitol Hill, UT",
      "seo_description": "Discover studio apartments at Skyhouse on Capitol Hill, UT. Experience modern living with panoramic views and urban amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "1-bedroom-apartment-salt-lake-city",
      "search_query": "1 bedroom apartment salt lake city",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Salt Lake City",
      "h2_subtitle": "Find your ideal 1 bedroom apartment at Skyhouse in Salt Lake City. Enjoy modern finishes and breathtaking city views.",
      "page_copy": "Skyhouse Apartments invites you to discover luxurious 1 bedroom apartments right in the heart of Salt Lake City. These homes offer a perfect blend of comfort and style, featuring modern finishes and south-facing windows that flood your living space with natural light.\n\nLocated near Capitol Hill, residents enjoy easy access to the city's key attractions and the scenic Wasatch mountains. With additional amenities such as a rooftop deck and convenient TRAX access, Skyhouse ensures that both relaxation and adventure are always nearby. Elevate your living experience with a 1 bedroom apartment at Skyhouse today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartment in Salt Lake City",
      "seo_description": "Explore 1 bedroom apartments at Skyhouse in Salt Lake City. Enjoy modern living with scenic views and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-downtown-salt-lake-county",
      "search_query": "2 bedroom apartments downtown salt lake county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Downtown Salt Lake County",
      "h2_subtitle": "Discover spacious 2 bedroom apartments at Skyhouse in downtown Salt Lake County. Modern living with city and mountain views awaits.",
      "page_copy": "Settle into the luxurious comfort of Skyhouse Apartments' 2 bedroom units located in the vibrant downtown area of Salt Lake County. These expansive homes are crafted with modern finishes and provide breathtaking views of both the city skyline and the majestic Wasatch mountains.\n\nPositioned in the lively Capitol Hill neighborhood, residents enjoy seamless access to both natural beauty and urban convenience. Our amenities include a stunning rooftop deck, complete with scenic vistas, and a package service for easy living. Choose Skyhouse Apartments for an elevated downtown living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Downtown Salt Lake County",
      "seo_description": "Explore spacious 2 bedroom apartments at Skyhouse in downtown Salt Lake County. Modern amenities and breathtaking views of the city.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "apartments-near-open-classroom-salt-lake-city",
      "search_query": "apartments near Open Classroom Salt Lake City",
      "category": "School",
      "h1_title": "Apartments Near Open Classroom in Salt Lake City",
      "h2_subtitle": "Discover convenient apartment living near Open Classroom in Salt Lake City at Skyhouse Apartments. Enjoy comfortable living with great amenities.",
      "page_copy": "Located just a short distance from Open Classroom in Salt Lake City, Skyhouse Apartments offer an ideal living solution for those seeking proximity to local educational institutions. Choose from a selection of beautifully finished studio, one-, and two-bedroom homes designed with both comfort and modern aesthetics in mind.\n\nReside in the vibrant Capitol Hill neighborhood and enjoy easy access to both nature and city life. With amenities like a rooftop deck offering panoramic views and reliable package service, Skyhouse ensures a balanced lifestyle full of convenience and elegance. Make Skyhouse your home and stay connected to the heart of education in Salt Lake City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Open Classroom Salt Lake City",
      "seo_description": "Find convenient living at Skyhouse Apartments near Open Classroom in Salt Lake City. Enjoy modern amenities and a central location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "skyhouse-apartments-near-wasatch-elementary",
      "search_query": "Skyhouse Apartments near Wasatch Elementary School UT",
      "category": "School",
      "h1_title": "Skyhouse Apartments Near Wasatch Elementary",
      "h2_subtitle": "Situated close to Wasatch Elementary School in UT, Skyhouse Apartments offer modern living with convenient access to education and amenities.",
      "page_copy": "Skyhouse Apartments provide a perfect residence for families and individuals seeking proximity to Wasatch Elementary School in UT. These well-appointed studio, one-, and two-bedroom homes offer a sophisticated blend of style and function, ideal for modern living.\n\nNestled in the Capitol Hill area of Salt Lake City, residents enjoy stunning skyline and mountain views, along with convenient TRAX access. With a range of amenities including a rooftop deck and meticulous maid service, Skyhouse ensures a comfortable and enjoyable living environment. Discover how this prime location can enhance your daily life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Skyhouse Apartments Near Wasatch Elementary School",
      "seo_description": "Live near Wasatch Elementary School at Skyhouse Apartments in UT. Enjoy modern amenities and a convenient location in Salt Lake City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "capitol-hill-apartments-near-west-high-school",
      "search_query": "Capitol Hill Salt Lake City apartments close to West High School",
      "category": "School",
      "h1_title": "Capitol Hill Apartments Near West High School",
      "h2_subtitle": "Discover Capitol Hill Salt Lake City apartments convenient to West High School. Modern living meets prime location at Skyhouse.",
      "page_copy": "Experience the vibrant lifestyle at Skyhouse Apartments, ideally located in the Capitol Hill area of Salt Lake City and close to West High School. Choose from an array of stylish studio, one-, and two-bedroom homes, all designed with contemporary finishes and fantastic amenities.\n\nLiving at Skyhouse means enjoying breathtaking city and mountain views from our stunning rooftop deck. In addition, the excellent location provides seamless access to both educational institutions and the cultural heart of Salt Lake City. Embrace modern living with the added benefit of being just minutes away from West High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Capitol Hill Apartments Near West High School",
      "seo_description": "Find Salt Lake City apartments in Capitol Hill close to West High School. Skyhouse offers modern amenities and a central, convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "ensign-college-nearby-apartments-salt-lake-county",
      "search_query": "Ensign College nearby apartments in Salt Lake County",
      "category": "School",
      "h1_title": "Nearby Apartments to Ensign College in Salt Lake",
      "h2_subtitle": "Explore nearby apartments to Ensign College in Salt Lake County. Skyhouse offers convenience and style perfect for students and professionals.",
      "page_copy": "Skyhouse Apartments in Salt Lake County provide a superb living choice near Ensign College, catering to both students and professionals seeking contemporary accommodations. Featuring stylish studio, one-, and two-bedroom options, Skyhouse combines modern design with functional living spaces.\n\nSituated in the Capitol Hill neighborhood, residents benefit from breathtaking city and mountain vistas. With amenities like a spacious deck and seamless TRAX access, living here offers both tranquility and connectivity. Discover the perfect balance of proximity to Ensign College and the luxury of metropolitan living at Skyhouse Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to Ensign College in Salt Lake",
      "seo_description": "Find Salt Lake County apartments near Ensign College at Skyhouse. Enjoy modern living with amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "apartments-near-city-academy-salt-lake-84101",
      "search_query": "apartments near City Academy Salt Lake 84101",
      "category": "School",
      "h1_title": "Apartments Near City Academy Salt Lake",
      "h2_subtitle": "Find apartments near City Academy in Salt Lake's 84101 area. Skyhouse offers a seamless blend of convenience and modern amenities.",
      "page_copy": "Skyhouse Apartments are perfectly situated near City Academy in Salt Lake, located in the vibrant 84101 area. Our elegant studio, one-, and two-bedroom homes offer an impeccable blend of contemporary design and quality finishes, ideal for students and professionals alike.\n\nNestled in the dynamic Capitol Hill neighborhood, Skyhouse provides stunning views and easy access to downtown energy. With features like efficient package services, maid service, and a breathtaking rooftop deck, you’ll discover that Skyhouse Apartments embody both luxury and convenience. Experience the ease of residing near City Academy while enjoying a premier living environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near City Academy Salt Lake 84101",
      "seo_description": "Discover modern apartments near City Academy in Salt Lake's 84101 area at Skyhouse, offering stylish amenities and prime access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "pinyon-montessori-close-by-apartments-capitol-hill",
      "search_query": "Pinyon Montessori close by apartments Capitol Hill",
      "category": "School",
      "h1_title": "Apartments Close to Pinyon Montessori",
      "h2_subtitle": "Discover apartments near Pinyon Montessori in Capitol Hill. Skyhouse offers modern living and easy access for families.",
      "page_copy": "Located in the scenic Capitol Hill area, Skyhouse Apartments are the perfect choice for those seeking proximity to Pinyon Montessori. Our studio, one-, and two-bedroom residences feature modern finishes and are ideal for families looking for a welcoming community.\n\nSkyhouse boasts a rooftop deck with panoramic views of the skyline and Wasatch Mountains. Residents benefit from convenient services such as package handling and maid services, making life hassle-free. Enjoy seamless access to Pinyon Montessori while soaking in the vibrant energy and convenience of Capitol Hill living at Skyhouse Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pinyon Montessori Capitol Hill",
      "seo_description": "Find Capitol Hill apartments near Pinyon Montessori at Skyhouse, offering stylish living and family-friendly amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "salt-lake-center-science-education-nearby-apartments",
      "search_query": "Salt Lake Center for Science Education nearby apartments",
      "category": "School",
      "h1_title": "Nearby Apartments to Science Education Center",
      "h2_subtitle": "Discover nearby apartments to Salt Lake Center for Science Education. Skyhouse offers comfortable living with modern amenities.",
      "page_copy": "Skyhouse Apartments caters to those seeking top-notch living accommodations near the Salt Lake Center for Science Education. Located in the energetic Capitol Hill neighborhood, our studio, one-, and two-bedroom homes are crafted with sleek, modern finishes catering to both students and families.\n\nEnjoy unparalleled views of the city and surrounding mountains from our rooftop deck. With convenient access to transportation and services like package delivery and maid service, Skyhouse offers a seamless, stress-free living experience. Immerse yourself in the vibrant community and enjoy close proximity to educational opportunities at the Science Education Center in Salt Lake City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Salt Lake Science Education Center",
      "seo_description": "Find apartments near Salt Lake Center for Science Education at Skyhouse, offering modern living and amenities in Capitol Hill.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "judge-memorial-catholic-high-school-salt-lake-city-apartments",
      "search_query": "Judge Memorial Catholic High School Salt Lake City apartments",
      "category": "School",
      "h1_title": "Apartments Near Judge Memorial High School",
      "h2_subtitle": "Explore Salt Lake City apartments near Judge Memorial Catholic High School. Experience convenient living at Skyhouse.",
      "page_copy": "Skyhouse Apartments provide an exceptional living choice for those wanting close proximity to Judge Memorial Catholic High School in Salt Lake City. Our stylish studio, one-, and two-bedroom residences offer the perfect blend of modern design and comfort, ideal for families and professionals alike.\n\nNestled within the Capitol Hill area, Skyhouse provides breathtaking views of the cityscape and Wasatch Mountains from its rooftop deck. With services like package handling and maid service, residents enjoy convenience and peace of mind. Experience the vibrant atmosphere of Salt Lake City while having easy access to educational institutions such as Judge Memorial Catholic High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Judge Memorial Catholic High School",
      "seo_description": "Discover Salt Lake City apartments near Judge Memorial Catholic High School at Skyhouse, boasting modern amenities and convenient access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-utah-salt-lake",
      "search_query": "apartments near University of Utah Salt Lake",
      "category": "School",
      "h1_title": "Apartments Near University of Utah",
      "h2_subtitle": "Discover stylish apartments near the University of Utah in Salt Lake City. Skyhouse offers modern amenities in a prime location.",
      "page_copy": "Skyhouse Apartments is an excellent choice for those searching for apartments near the University of Utah in Salt Lake City. Our contemporary studio, one-, and two-bedroom homes are designed to offer a blend of comfort and style, perfect for students and faculty seeking a convenient location.\n\nSituated in the vibrant Capitol Hill neighborhood, Skyhouse provides easy access to public transit and essential services like package and maid service. From our rooftop deck, take in sweeping views of the city skyline and the picturesque Wasatch Mountains. Live close to campus while enjoying the energy and amenities that downtown Salt Lake City has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Utah, Salt Lake City",
      "seo_description": "Find modern apartments near the University of Utah at Skyhouse, featuring convenient services and breathtaking views in Salt Lake City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "apartments-near-intermountain-health-lds-hospital-salt-lake",
      "search_query": "apartments near Intermountain Health LDS Hospital downtown Salt Lake City",
      "category": "Hospital",
      "h1_title": "Apartments Near LDS Hospital Salt Lake City",
      "h2_subtitle": "Find stylish apartments near Intermountain Health LDS Hospital in downtown Salt Lake City. Skyhouse offers modern living options.",
      "page_copy": "Skyhouse Apartments presents an ideal living solution for medical professionals and families searching for apartments near Intermountain Health LDS Hospital in downtown Salt Lake City. Our beautiful studio, one-, and two-bedroom apartments combine elegance with practicality, making city life both comfortable and convenient.\n\nLocated in the bustling Capitol Hill area, residents enjoy close proximity to essential services like package handling and maid service, along with spectacular rooftop views of the Salt Lake skyline. Easy access to TRAX connects you effortlessly to the hospital and other key destinations, making commuting a breeze. Embrace vibrant urban living while staying near your workplace at Skyhouse Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by LDS Hospital, Salt Lake City",
      "seo_description": "Explore modern apartments near Intermountain Health LDS Hospital at Skyhouse, offering convenience and comfort in downtown Salt Lake City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "skyhouse-apartments-near-commonspirit-holy-cross-hospital",
      "search_query": "Skyhouse Apartments close to CommonSpirit Holy Cross Hospital Capitol Hill",
      "category": "Hospital",
      "h1_title": "Skyhouse Near Holy Cross Hospital",
      "h2_subtitle": "Discover Skyhouse Apartments close to CommonSpirit Holy Cross Hospital in Capitol Hill. Enjoy modern amenities and prime location.",
      "page_copy": "Skyhouse Apartments offers a prime living spot for those looking to be near CommonSpirit Holy Cross Hospital in the Capitol Hill area. Our chic studio, one-, and two-bedroom residences provide a comfortable, urban living experience with easy access to healthcare facilities and city attractions.\n\nLocated in vibrant Capitol Hill, Skyhouse provides residents with impressive views of the Wasatch Mountains and downtown skyline from the rooftop deck. With convenient amenities such as package service and maid service, daily life is streamlined and hassle-free. Being close to TRAX means the rest of Salt Lake City is easily accessible, ensuring you can balance work, leisure, and relaxation with ease.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Skyhouse Apts Near Holy Cross Hospital",
      "seo_description": "Live at Skyhouse Apartments near CommonSpirit Holy Cross Hospital, Capitol Hill with modern amenities and breathtaking views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "apartments-near-city-creek-park-salt-lake-city",
      "search_query": "apartments near City Creek Park Salt Lake City",
      "category": "Park",
      "h1_title": "Apartments Near City Creek Park",
      "h2_subtitle": "Find the perfect apartments near City Creek Park in Salt Lake City. Skyhouse Apartments offers a prime location with modern amenities.",
      "page_copy": "Skyhouse Apartments presents a luxurious retreat for urban dwellers looking for apartments near City Creek Park in Salt Lake City. Our stylish studio, one-, and two-bedroom homes are perfectly located in the lively Capitol Hill neighborhood, offering easy access to the beautiful City Creek Park.\n\nEnjoy a seamless lifestyle with amenities like package service and maid service, designed to provide you with comfort and convenience. Take in the stunning views of the Wasatch Mountains and downtown Salt Lake City from our rooftop deck. With nearby TRAX access, exploring the city's vibrant culture, shopping, and dining options becomes effortless, offering you the best of city living right at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by City Creek Park, Salt Lake City",
      "seo_description": "Discover modern apartments at Skyhouse near City Creek Park, Salt Lake City, offering stylish living and convenient city access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "apartments-close-to-memory-grove-capitol-hill",
      "search_query": "apartments close to Memory Grove Capitol Hill",
      "category": "Park",
      "h1_title": "Apartments Near Memory Grove Park",
      "h2_subtitle": "Discover Skyhouse Apartments close to Memory Grove in Capitol Hill for modern living with a scenic touch. Ideal urban lifestyle awaits.",
      "page_copy": "Experience the harmony of nature and urban life at Skyhouse Apartments, ideally located near Memory Grove in Capitol Hill. Our studio, one-, and two-bedroom apartments offer residents modern comforts and impressive city and mountain views right from their doorstep.\n\nWith access to essential services such as package handling and maid service, Skyhouse ensures convenience and ease. The proximity to peaceful Memory Grove Park means you can enjoy leisurely walks and tranquil picnics while still being connected to Salt Lake City's vibrant downtown. Effortless access to TRAX ensures you're always close to the essential city spots, making living here both comfortable and exciting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Memory Grove Park",
      "seo_description": "Explore Skyhouse Apartments close to Memory Grove, Capitol Hill. Enjoy modern amenities and lush park proximity in Salt Lake City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "apartments-near-north-temple-bridge-guadalupe",
      "search_query": "apartments near north temple bridge guadalupe salt lake county",
      "category": "Transit",
      "h1_title": "Apartments by North Temple Bridge",
      "h2_subtitle": "Explore Skyhouse Apartments near North Temple Bridge in Guadalupe, Salt Lake County. Enjoy seamless connectivity and urban living.",
      "page_copy": "Skyhouse Apartments offers a contemporary living experience near the North Temple Bridge in Guadalupe, Salt Lake City. Ideal for those seeking a convenient location, our studio, one-, and two-bedroom homes provide a perfect blend of style and accessibility.\n\nLocated in the thriving Capitol Hill neighborhood, residents can take advantage of easy access to TRAX and the wider Salt Lake County, making commutes a breeze. Our apartments also feature modern amenities, including package service and maid service, designed to simplify urban living. With a range of retail, dining, and entertainment venues nearby, you'll find connectivity and recreation right at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near North Temple Bridge Guadalupe",
      "seo_description": "Discover modern living at Skyhouse Apartments near North Temple Bridge, Guadalupe, Salt Lake City. Enjoy convenience and vibrant city life.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "apartments-close-to-arena-station-salt-lake-city",
      "search_query": "apartments close to arena station salt lake city",
      "category": "Transit",
      "h1_title": "Apartments Near Arena Station",
      "h2_subtitle": "Find your new home at Skyhouse Apartments close to Arena Station in Salt Lake City. Enjoy easy transit and modern amenities.",
      "page_copy": "Live in the heart of Salt Lake City at Skyhouse Apartments, ideally situated close to Arena Station. Our polished studio, one-, and two-bedroom apartments offer you convenient access to the city's dynamic pulse, making it perfect for those who value accessibility and modern living.\n\nResiding here means you're just steps away from the TRAX line at Arena Station, allowing you seamless travel throughout the city. With stunning views from our rooftop deck and amenities like package and maid services, Skyhouse Apartments ensures a comfortable and connected lifestyle. Embrace city living while enjoying the tranquility of Capitol Hill's unique environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Arena Station, Salt Lake City",
      "seo_description": "Discover Skyhouse Apartments close to Arena Station, perfect for urban living in Salt Lake City with modern amenities and transit convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "apartments-by-planetarium-station-capitol-hill",
      "search_query": "apartments by planetarium station capitol hill",
      "category": "Transit",
      "h1_title": "Apartments Near Planetarium Station",
      "h2_subtitle": "Explore Skyhouse Apartments by Planetarium Station in Capitol Hill. Experience contemporary city living with transit at your doorstep.",
      "page_copy": "Skyhouse Apartments offers an ideal urban living experience near Planetarium Station in Capitol Hill. Our studio, one-, and two-bedroom homes place you at the center of vibrant city life while providing stunning views and modern conveniences.\n\nBeing located by Planetarium Station ensures you have easy access to the entire TRAX network and all that Salt Lake City offers. Enjoy amenities like package service and maid service, designed to make daily life easier. At Skyhouse, you’re not just choosing an apartment; you're choosing a lifestyle that combines comfort and connectivity in a prime Capitol Hill location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Planetarium Station Capitol Hill",
      "seo_description": "Find modern living at Skyhouse Apartments near Planetarium Station, Capitol Hill. Enjoy easy city access and superb amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "city-center-nearby-apartments-salt-lake-city",
      "search_query": "city center nearby apartments salt lake city",
      "category": "Transit",
      "h1_title": "City Center Apartments in Salt Lake City",
      "h2_subtitle": "Discover Skyhouse Apartments near Salt Lake City's city center. Enjoy the convenience of urban living with stunning views and modern amenities.",
      "page_copy": "Discover the convenience of living near Salt Lake City's city center with Skyhouse Apartments. Our studio, one-, and two-bedroom homes offer the perfect blend of urban accessibility and upscale comfort in a vibrant setting.\n\nLocated in Capitol Hill, Skyhouse Apartments boasts easy access to city hotspots and the TRAX system, making commuting a breeze. Enjoy a range of thoughtful amenities, including a south-facing deck and package service, ensuring you have seamless integration into city life while relaxing in style. It's more than just where you live—it's joining a community in the heart of Salt Lake City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "City Center Apartments, Salt Lake City",
      "seo_description": "Explore Skyhouse Apartments near Salt Lake City's city center. Enjoy urban living with modern amenities and easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "apartments-near-old-greek-town-84101",
      "search_query": "apartments near old greek town 84101",
      "category": "Transit",
      "h1_title": "Apartments by Old Greek Town 84101",
      "h2_subtitle": "Skyhouse Apartments offers urban living near Old Greek Town in 84101. Experience the charm of historic Salt Lake City with modern conveniences.",
      "page_copy": "Uncover a unique blend of history and modern living at Skyhouse Apartments, located near Old Greek Town in the 84101 area. Our studio, one-, and two-bedroom homes are perfectly positioned for those who enjoy the charm of historic neighborhoods coupled with the vibrancy of city life.\n\nSituated in Capitol Hill, residents of Skyhouse have easy access to the rich cultural and historic offerings of Old Greek Town, while also enjoying the spectacular skyline and mountain views. With amenities like maid service and a south-facing deck, Skyhouse provides comfort and convenience in an iconic Salt Lake City setting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Old Greek Town, 84101",
      "seo_description": "Live at Skyhouse Apartments near Old Greek Town in the 84101 area. Perfect blend of historic charm and modern conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "apartments-close-to-library-station-capitol-hill",
      "search_query": "apartments close to library station capitol hill",
      "category": "Transit",
      "h1_title": "Apartments Near Library Station, Capitol Hill",
      "h2_subtitle": "Discover Skyhouse Apartments near Library Station in Capitol Hill. Enjoy seamless transit access and exceptional living in Salt Lake City.",
      "page_copy": "Skyhouse Apartments stands out as a premier choice for urban living near Library Station in Capitol Hill. With studio, one-, and two-bedroom options, residents enjoy proximity to TRAX, making commuting around Salt Lake City effortless.\n\nThe convenience of being near Library Station means easy access to city amenities while residing in a home with breathtaking skyline and Wasatch views. Our exceptional amenities, such as package service and maid service, ensure a comfortable lifestyle amidst the bustling Capitol Hill neighborhood. At Skyhouse, you experience modern convenience with a touch of elegance in Salt Lake City's vibrant setting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Library Station, Capitol Hill",
      "seo_description": "Explore Skyhouse Apartments near Library Station in Capitol Hill. Enjoy urban living with seamless transit access and stylish amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162467",
      "property_id": "6767906449167707",
      "source": "generator",
      "page_item_url": "apartments-near-salt-lake-city-international-airport",
      "search_query": "apartments near salt lake city international airport utah",
      "category": "Transit",
      "h1_title": "Apartments by Salt Lake City Airport",
      "h2_subtitle": "Discover the convenience of living near Salt Lake City International Airport at Skyhouse Apartments. Enjoy urban sophistication with easy access to travel and transit.",
      "page_copy": "Experience the ideal location of Skyhouse Apartments, situated conveniently near the Salt Lake City International Airport in Utah. Our modern studio, one-, and two-bedroom homes provide the perfect base for frequent travelers or professionals seeking proximity to major transportation hubs.\n\nLocated in the Capitol Hill area, residents enjoy not just easy airport access but also breathtaking views of the skyline and surrounding mountains. Skyhouse offers amenities like a relaxing deck and diligent maid service, combining luxury living with utmost convenience. It's the perfect urban retreat for those on the go, offering a stylish haven in Salt Lake City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
      "featured_image_media": {
        "alt_text": "Rooftop patio with outdoor kitchen, dining table, and city view.",
        "public_id": "01a01aea-8c43-716d-8dbe-33517eda97ba",
        "storage_key": "property/6767906449167707/01a01aea-8c43-716d-8dbe-33517eda97ba.webp",
        "width": 2048,
        "height": 1368
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Salt Lake City Airport, Utah",
      "seo_description": "Skyhouse Apartments provide easy access to Salt Lake City International Airport. Enjoy urban living with spectacular views and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12845299138"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KH6SKDXZ"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/1ywy7367wq0"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-459-3042"
    }
  ],
  "custom_repli_id": "12845299138",
  "custom_google_gtm_id": "GTM-KH6SKDXZ",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/1ywy7367wq0",
  "custom_ppc_tracking_phone_number": "844-459-3042"
};

export const generatedAt = '2026-08-27T17:48:45.463Z';
